
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2YaGf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a76a3f4404ba59acd822415adfff8b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2299784d377cc441$var$_react = $2299784d377cc441$var$_interopRequireDefault((parcelRequire("42omo")));

var $2299784d377cc441$var$_file = $2299784d377cc441$var$_interopRequireDefault((parcelRequire("chO1Z")));

var $2299784d377cc441$var$_documentFilled = $2299784d377cc441$var$_interopRequireDefault((parcelRequire("1d4Mb")));
function $2299784d377cc441$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2299784d377cc441$var$FileIcon = (props)=>/*#__PURE__*/ $2299784d377cc441$var$_react.default.createElement($2299784d377cc441$var$_file.default, Object.assign({
        name: "FileIcon",
        LEGACY_fallbackIcon: $2299784d377cc441$var$_documentFilled.default
    }, props));
$2299784d377cc441$var$FileIcon.displayName = 'FileIconMigration';
var $2299784d377cc441$var$_default = module.exports.default = $2299784d377cc441$var$FileIcon;

});

parcelRegister("1d4Mb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e1ab5c657b2b56c$var$_react = $0e1ab5c657b2b56c$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0e1ab5c657b2b56c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0e1ab5c657b2b56c$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $0e1ab5c657b2b56c$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props));
$0e1ab5c657b2b56c$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $0e1ab5c657b2b56c$var$_default = module.exports.default = $0e1ab5c657b2b56c$var$DocumentFilledIcon;

});

parcelRegister("8Q3VW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c7207a1a192d06bb66aba669d57a8645>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66f63b26ff459985$var$_react = $66f63b26ff459985$var$_interopRequireDefault((parcelRequire("42omo")));

var $66f63b26ff459985$var$_link = $66f63b26ff459985$var$_interopRequireDefault((parcelRequire("1bY7o")));

var $66f63b26ff459985$var$_link2 = $66f63b26ff459985$var$_interopRequireDefault((parcelRequire("2D7De")));
function $66f63b26ff459985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66f63b26ff459985$var$LinkIcon = (props)=>/*#__PURE__*/ $66f63b26ff459985$var$_react.default.createElement($66f63b26ff459985$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $66f63b26ff459985$var$_link2.default
    }, props));
$66f63b26ff459985$var$LinkIcon.displayName = 'LinkIconMigration';
var $66f63b26ff459985$var$_default = module.exports.default = $66f63b26ff459985$var$LinkIcon;

});

parcelRegister("2D7De", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ea524d030f682a2$var$_react = $1ea524d030f682a2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $1ea524d030f682a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ea524d030f682a2$var$LinkIcon = (props)=>/*#__PURE__*/ $1ea524d030f682a2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$1ea524d030f682a2$var$LinkIcon.displayName = 'LinkIcon';
var $1ea524d030f682a2$var$_default = module.exports.default = $1ea524d030f682a2$var$LinkIcon;

});

parcelRegister("2Agkp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e1b9c0416839800$var$_react = $1e1b9c0416839800$var$_interopRequireDefault((parcelRequire("42omo")));

var $1e1b9c0416839800$var$_statusError = $1e1b9c0416839800$var$_interopRequireDefault((parcelRequire("a3fRD")));

var $1e1b9c0416839800$var$_error = $1e1b9c0416839800$var$_interopRequireDefault((parcelRequire("8QILn")));
function $1e1b9c0416839800$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e1b9c0416839800$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $1e1b9c0416839800$var$_react.default.createElement($1e1b9c0416839800$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $1e1b9c0416839800$var$_error.default
    }, props));
$1e1b9c0416839800$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $1e1b9c0416839800$var$_default = module.exports.default = $1e1b9c0416839800$var$StatusErrorIcon;

});

parcelRegister("a3fRD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75167d7dae69ba18$var$_react = $75167d7dae69ba18$var$_interopRequireDefault((parcelRequire("42omo")));

var $75167d7dae69ba18$var$_baseNew = $75167d7dae69ba18$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $75167d7dae69ba18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75167d7dae69ba18$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $75167d7dae69ba18$var$_react.default.createElement($75167d7dae69ba18$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$75167d7dae69ba18$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $75167d7dae69ba18$var$_default = module.exports.default = $75167d7dae69ba18$var$StatusErrorIcon;

});

parcelRegister("dk0le", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17bb883bd3a73bc5f5c12f88ac81607a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b2d686d1e19d4a3$var$_react = $9b2d686d1e19d4a3$var$_interopRequireDefault((parcelRequire("42omo")));

var $9b2d686d1e19d4a3$var$_baseNew = $9b2d686d1e19d4a3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9b2d686d1e19d4a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b2d686d1e19d4a3$var$GridIcon = (props)=>/*#__PURE__*/ $9b2d686d1e19d4a3$var$_react.default.createElement($9b2d686d1e19d4a3$var$_baseNew.default, Object.assign({
        name: "GridIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$9b2d686d1e19d4a3$var$GridIcon.displayName = 'GridIcon';
var $9b2d686d1e19d4a3$var$_default = module.exports.default = $9b2d686d1e19d4a3$var$GridIcon;

});

parcelRegister("jdPfT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfe6fd76b327f8ff$var$_react = $dfe6fd76b327f8ff$var$_interopRequireDefault((parcelRequire("42omo")));

var $dfe6fd76b327f8ff$var$_baseNew = $dfe6fd76b327f8ff$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dfe6fd76b327f8ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dfe6fd76b327f8ff$var$AppIcon = (props)=>/*#__PURE__*/ $dfe6fd76b327f8ff$var$_react.default.createElement($dfe6fd76b327f8ff$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$dfe6fd76b327f8ff$var$AppIcon.displayName = 'AppIcon';
var $dfe6fd76b327f8ff$var$_default = module.exports.default = $dfe6fd76b327f8ff$var$AppIcon;

});

parcelRegister("lcVFI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f707746817909a09$var$_react = $f707746817909a09$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f707746817909a09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f707746817909a09$var$AddonIcon = (props)=>/*#__PURE__*/ $f707746817909a09$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props));
$f707746817909a09$var$AddonIcon.displayName = 'AddonIcon';
var $f707746817909a09$var$_default = module.exports.default = $f707746817909a09$var$AddonIcon;

});

parcelRegister("dxJ1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dc1477630fb60b7$var$_react = $9dc1477630fb60b7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9dc1477630fb60b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9dc1477630fb60b7$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $9dc1477630fb60b7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props));
$9dc1477630fb60b7$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $9dc1477630fb60b7$var$_default = module.exports.default = $9dc1477630fb60b7$var$ArrowDownIcon;

});

parcelRegister("32wsW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $236abe0d426ad061$var$_react = $236abe0d426ad061$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $236abe0d426ad061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $236abe0d426ad061$var$CalendarIcon = (props)=>/*#__PURE__*/ $236abe0d426ad061$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props));
$236abe0d426ad061$var$CalendarIcon.displayName = 'CalendarIcon';
var $236abe0d426ad061$var$_default = module.exports.default = $236abe0d426ad061$var$CalendarIcon;

});

parcelRegister("66FuL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47237db4280a4567$var$_react = $47237db4280a4567$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $47237db4280a4567$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47237db4280a4567$var$CheckIcon = (props)=>/*#__PURE__*/ $47237db4280a4567$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props));
$47237db4280a4567$var$CheckIcon.displayName = 'CheckIcon';
var $47237db4280a4567$var$_default = module.exports.default = $47237db4280a4567$var$CheckIcon;

});

parcelRegister("klvaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecfdf350e71d82e2$var$_react = $ecfdf350e71d82e2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $ecfdf350e71d82e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ecfdf350e71d82e2$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ecfdf350e71d82e2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$ecfdf350e71d82e2$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $ecfdf350e71d82e2$var$_default = module.exports.default = $ecfdf350e71d82e2$var$ChevronDownIcon;

});

parcelRegister("eowPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7acc566b38a2092$var$_react = $a7acc566b38a2092$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $a7acc566b38a2092$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a7acc566b38a2092$var$ChevronRightCircleIcon = (props)=>/*#__PURE__*/ $a7acc566b38a2092$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
    }, props));
$a7acc566b38a2092$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
var $a7acc566b38a2092$var$_default = module.exports.default = $a7acc566b38a2092$var$ChevronRightCircleIcon;

});

parcelRegister("5mdwm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e697ed2d81c806b$var$_react = $3e697ed2d81c806b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e697ed2d81c806b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e697ed2d81c806b$var$CopyIcon = (props)=>/*#__PURE__*/ $3e697ed2d81c806b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$3e697ed2d81c806b$var$CopyIcon.displayName = 'CopyIcon';
var $3e697ed2d81c806b$var$_default = module.exports.default = $3e697ed2d81c806b$var$CopyIcon;

});

parcelRegister("jJfRl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03b4e11f747a1cd0$var$_react = $03b4e11f747a1cd0$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $03b4e11f747a1cd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $03b4e11f747a1cd0$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $03b4e11f747a1cd0$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props));
$03b4e11f747a1cd0$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $03b4e11f747a1cd0$var$_default = module.exports.default = $03b4e11f747a1cd0$var$CrossCircleIcon;

});

parcelRegister("lkHRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f87d7dbf0df3ec32$var$_react = $f87d7dbf0df3ec32$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f87d7dbf0df3ec32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f87d7dbf0df3ec32$var$EditorAlignCenterIcon = (props)=>/*#__PURE__*/ $f87d7dbf0df3ec32$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m2.5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2m0-8h5a1 1 0 0 1 0 2h-5a1 1 0 1 1 0-2"/></svg>`
    }, props));
$f87d7dbf0df3ec32$var$EditorAlignCenterIcon.displayName = 'EditorAlignCenterIcon';
var $f87d7dbf0df3ec32$var$_default = module.exports.default = $f87d7dbf0df3ec32$var$EditorAlignCenterIcon;

});

parcelRegister("4z9XK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $353228b09d42deb9$var$_react = $353228b09d42deb9$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $353228b09d42deb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $353228b09d42deb9$var$EditorAlignImageLeftIcon = (props)=>/*#__PURE__*/ $353228b09d42deb9$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$353228b09d42deb9$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var $353228b09d42deb9$var$_default = module.exports.default = $353228b09d42deb9$var$EditorAlignImageLeftIcon;

});

parcelRegister("iCiYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8da7e74bf2a2c8a$var$_react = $d8da7e74bf2a2c8a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d8da7e74bf2a2c8a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8da7e74bf2a2c8a$var$EditorAlignLeftIcon = (props)=>/*#__PURE__*/ $d8da7e74bf2a2c8a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 4h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m0 4h5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
    }, props));
$d8da7e74bf2a2c8a$var$EditorAlignLeftIcon.displayName = 'EditorAlignLeftIcon';
var $d8da7e74bf2a2c8a$var$_default = module.exports.default = $d8da7e74bf2a2c8a$var$EditorAlignLeftIcon;

});

parcelRegister("4EFIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $363b437b603bd687$var$_react = $363b437b603bd687$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $363b437b603bd687$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $363b437b603bd687$var$EditorAlignRightIcon = (props)=>/*#__PURE__*/ $363b437b603bd687$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 11h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2m5 4h5a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2"/></svg>`
    }, props));
$363b437b603bd687$var$EditorAlignRightIcon.displayName = 'EditorAlignRightIcon';
var $363b437b603bd687$var$_default = module.exports.default = $363b437b603bd687$var$EditorAlignRightIcon;

});

parcelRegister("bX0fK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b35669de7b603fd$var$_react = $8b35669de7b603fd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $8b35669de7b603fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8b35669de7b603fd$var$EditorBoldIcon = (props)=>/*#__PURE__*/ $8b35669de7b603fd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h4.832C13.908 6 16 6.5 16 9q0 2-1 2.5 2 .5 2 3c0 .5 0 3.5-4 3.5H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m1 10h3.5c1 0 2-.25 2-1.5s-1.104-1.5-2-1.5H9zm0-4.975h3c.504 0 2 0 2-1.525S12 8 12 8H9z"/></svg>`
    }, props));
$8b35669de7b603fd$var$EditorBoldIcon.displayName = 'EditorBoldIcon';
var $8b35669de7b603fd$var$_default = module.exports.default = $8b35669de7b603fd$var$EditorBoldIcon;

});

parcelRegister("8JMZ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01a44438868f62fb$var$_react = $01a44438868f62fb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $01a44438868f62fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01a44438868f62fb$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $01a44438868f62fb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props));
$01a44438868f62fb$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $01a44438868f62fb$var$_default = module.exports.default = $01a44438868f62fb$var$EditorDecisionIcon;

});

parcelRegister("6Eilg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d74b4d49d7f9e28$var$_react = $4d74b4d49d7f9e28$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $4d74b4d49d7f9e28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4d74b4d49d7f9e28$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $4d74b4d49d7f9e28$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props));
$4d74b4d49d7f9e28$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $4d74b4d49d7f9e28$var$_default = module.exports.default = $4d74b4d49d7f9e28$var$EditorDoneIcon;

});

parcelRegister("inR50", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d6238c7de111df00$var$_react = $d6238c7de111df00$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d6238c7de111df00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d6238c7de111df00$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $d6238c7de111df00$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props));
$d6238c7de111df00$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $d6238c7de111df00$var$_default = module.exports.default = $d6238c7de111df00$var$EditorExpandIcon;

});

parcelRegister("fEmHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b64c326fa34c1498$var$_react = $b64c326fa34c1498$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b64c326fa34c1498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b64c326fa34c1498$var$EditorFileIcon = (props)=>/*#__PURE__*/ $b64c326fa34c1498$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.51.51 0 0 1-.51-.5zm5 1v2.999c0 .271.225.501.501.501H15.5z"/></svg>`
    }, props));
$b64c326fa34c1498$var$EditorFileIcon.displayName = 'EditorFileIcon';
var $b64c326fa34c1498$var$_default = module.exports.default = $b64c326fa34c1498$var$EditorFileIcon;

});

parcelRegister("5b9Z9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c55b9b21da9111a$var$_react = $3c55b9b21da9111a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3c55b9b21da9111a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c55b9b21da9111a$var$EditorHorizontalRuleIcon = (props)=>/*#__PURE__*/ $3c55b9b21da9111a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="14" height="2" x="5" y="11" fill="currentcolor" fill-rule="evenodd" rx="1"/></svg>`
    }, props));
$3c55b9b21da9111a$var$EditorHorizontalRuleIcon.displayName = 'EditorHorizontalRuleIcon';
var $3c55b9b21da9111a$var$_default = module.exports.default = $3c55b9b21da9111a$var$EditorHorizontalRuleIcon;

});

parcelRegister("glU04", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be7a0bf42fc65d75$var$_react = $be7a0bf42fc65d75$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $be7a0bf42fc65d75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be7a0bf42fc65d75$var$EditorImageIcon = (props)=>/*#__PURE__*/ $be7a0bf42fc65d75$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11 15-1-1-2 2h8v-1.8L14 12zM6 6.5c0-.276.229-.5.5-.5h11c.276 0 .5.229.5.5v11c0 .276-.229.5-.5.5h-11a.504.504 0 0 1-.5-.5zM9.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/></svg>`
    }, props));
$be7a0bf42fc65d75$var$EditorImageIcon.displayName = 'EditorImageIcon';
var $be7a0bf42fc65d75$var$_default = module.exports.default = $be7a0bf42fc65d75$var$EditorImageIcon;

});

parcelRegister("cDCCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93371532794084ab$var$_react = $93371532794084ab$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $93371532794084ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93371532794084ab$var$EditorIndentIcon = (props)=>/*#__PURE__*/ $93371532794084ab$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9 9H6.49a.495.495 0 0 0-.49.505v.99c0 .291.22.505.49.505H9v2l3-3-3-3zm4-1.495c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018A.49.49 0 0 1 13 8.495zm0 4c0-.279.228-.505.491-.505h5.018a.49.49 0 0 1 .491.505v.99a.503.503 0 0 1-.491.505h-5.018a.49.49 0 0 1-.491-.505zm-6 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 0 1-.5.505h-11a.495.495 0 0 1-.5-.505z"/></svg>`
    }, props));
$93371532794084ab$var$EditorIndentIcon.displayName = 'EditorIndentIcon';
var $93371532794084ab$var$_default = module.exports.default = $93371532794084ab$var$EditorIndentIcon;

});

parcelRegister("4AGyV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $357b8a38e9dc384b$var$_react = $357b8a38e9dc384b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $357b8a38e9dc384b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $357b8a38e9dc384b$var$EditorItalicIcon = (props)=>/*#__PURE__*/ $357b8a38e9dc384b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10 6h6a1 1 0 0 1 0 2h-6a1 1 0 1 1 0-2M8 16h6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m4-8h2l-2 8h-2z"/></svg>`
    }, props));
$357b8a38e9dc384b$var$EditorItalicIcon.displayName = 'EditorItalicIcon';
var $357b8a38e9dc384b$var$_default = module.exports.default = $357b8a38e9dc384b$var$EditorItalicIcon;

});

parcelRegister("31Ui6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $234d21504a395e9c$var$_react = $234d21504a395e9c$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $234d21504a395e9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $234d21504a395e9c$var$EditorLayoutSingleIcon = (props)=>/*#__PURE__*/ $234d21504a395e9c$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><rect width="16" height="14" x="4" y="5" fill="currentcolor" rx="2"/></svg>`
    }, props));
$234d21504a395e9c$var$EditorLayoutSingleIcon.displayName = 'EditorLayoutSingleIcon';
var $234d21504a395e9c$var$_default = module.exports.default = $234d21504a395e9c$var$EditorLayoutSingleIcon;

});

parcelRegister("lS9G7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fec6260b91f6d0cb$var$_react = $fec6260b91f6d0cb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $fec6260b91f6d0cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fec6260b91f6d0cb$var$EditorLayoutThreeEqualIcon = (props)=>/*#__PURE__*/ $fec6260b91f6d0cb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m6 0h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$fec6260b91f6d0cb$var$EditorLayoutThreeEqualIcon.displayName = 'EditorLayoutThreeEqualIcon';
var $fec6260b91f6d0cb$var$_default = module.exports.default = $fec6260b91f6d0cb$var$EditorLayoutThreeEqualIcon;

});

parcelRegister("9HSvn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $711268c419a78454$var$_react = $711268c419a78454$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $711268c419a78454$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $711268c419a78454$var$EditorLayoutTwoEqualIcon = (props)=>/*#__PURE__*/ $711268c419a78454$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m9 0h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$711268c419a78454$var$EditorLayoutTwoEqualIcon.displayName = 'EditorLayoutTwoEqualIcon';
var $711268c419a78454$var$_default = module.exports.default = $711268c419a78454$var$EditorLayoutTwoEqualIcon;

});

parcelRegister("fBY8v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5d8f584272cb568$var$_react = $b5d8f584272cb568$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $b5d8f584272cb568$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b5d8f584272cb568$var$EditorLayoutTwoLeftSidebarIcon = (props)=>/*#__PURE__*/ $b5d8f584272cb568$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M5 5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1m5 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$b5d8f584272cb568$var$EditorLayoutTwoLeftSidebarIcon.displayName = 'EditorLayoutTwoLeftSidebarIcon';
var $b5d8f584272cb568$var$_default = module.exports.default = $b5d8f584272cb568$var$EditorLayoutTwoLeftSidebarIcon;

});

parcelRegister("bWDfG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b238f1d3230639a$var$_react = $8b238f1d3230639a$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $8b238f1d3230639a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8b238f1d3230639a$var$EditorMediaFullWidthIcon = (props)=>/*#__PURE__*/ $8b238f1d3230639a$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props));
$8b238f1d3230639a$var$EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var $8b238f1d3230639a$var$_default = module.exports.default = $8b238f1d3230639a$var$EditorMediaFullWidthIcon;

});

parcelRegister("5042u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a4015f00670e09b$var$_react = $3a4015f00670e09b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3a4015f00670e09b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3a4015f00670e09b$var$EditorMediaWrapLeftIcon = (props)=>/*#__PURE__*/ $3a4015f00670e09b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$3a4015f00670e09b$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var $3a4015f00670e09b$var$_default = module.exports.default = $3a4015f00670e09b$var$EditorMediaWrapLeftIcon;

});

parcelRegister("gTjFa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c1090bcfbfabc6$var$_react = $c4c1090bcfbfabc6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $c4c1090bcfbfabc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4c1090bcfbfabc6$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $c4c1090bcfbfabc6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props));
$c4c1090bcfbfabc6$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $c4c1090bcfbfabc6$var$_default = module.exports.default = $c4c1090bcfbfabc6$var$EditorMediaWrapRightIcon;

});

parcelRegister("aBZC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b9d27340cfd78ca$var$_react = $7b9d27340cfd78ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $7b9d27340cfd78ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b9d27340cfd78ca$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $7b9d27340cfd78ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props));
$7b9d27340cfd78ca$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $7b9d27340cfd78ca$var$_default = module.exports.default = $7b9d27340cfd78ca$var$EditorMentionIcon;

});

parcelRegister("buUDP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85ee6eddc9c300ba$var$_react = $85ee6eddc9c300ba$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $85ee6eddc9c300ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85ee6eddc9c300ba$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $85ee6eddc9c300ba$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props));
$85ee6eddc9c300ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $85ee6eddc9c300ba$var$_default = module.exports.default = $85ee6eddc9c300ba$var$EditorMoreIcon;

});

parcelRegister("4ODVn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $381acd142f8c45f5$var$_react = $381acd142f8c45f5$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $381acd142f8c45f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $381acd142f8c45f5$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $381acd142f8c45f5$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$381acd142f8c45f5$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $381acd142f8c45f5$var$_default = module.exports.default = $381acd142f8c45f5$var$EditorNoteIcon;

});

parcelRegister("dGf3x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f5ae072a5955827$var$_react = $9f5ae072a5955827$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9f5ae072a5955827$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f5ae072a5955827$var$EditorNumberListIcon = (props)=>/*#__PURE__*/ $9f5ae072a5955827$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 7h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m0 4h6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2m-5 0h3v1H6zm0 2h3v1H6zm1-9H6V7h2v3H7zm-1 3h3v1.333h-.6V13H7.2v-.667H6zm0 2h3v1H6zm2 3h2v1H8z"/></svg>`
    }, props));
$9f5ae072a5955827$var$EditorNumberListIcon.displayName = 'EditorNumberListIcon';
var $9f5ae072a5955827$var$_default = module.exports.default = $9f5ae072a5955827$var$EditorNumberListIcon;

});

parcelRegister("gmTTR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beaa0ffb904bfb58$var$_react = $beaa0ffb904bfb58$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $beaa0ffb904bfb58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $beaa0ffb904bfb58$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $beaa0ffb904bfb58$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props));
$beaa0ffb904bfb58$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $beaa0ffb904bfb58$var$_default = module.exports.default = $beaa0ffb904bfb58$var$EditorPanelIcon;

});

parcelRegister("66gZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47107bddb364dc30$var$_react = $47107bddb364dc30$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $47107bddb364dc30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47107bddb364dc30$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $47107bddb364dc30$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props));
$47107bddb364dc30$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $47107bddb364dc30$var$_default = module.exports.default = $47107bddb364dc30$var$EditorSearchIcon;

});

parcelRegister("a6h9M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75a7c5e2ad9a76cd$var$_react = $75a7c5e2ad9a76cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $75a7c5e2ad9a76cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $75a7c5e2ad9a76cd$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $75a7c5e2ad9a76cd$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props));
$75a7c5e2ad9a76cd$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $75a7c5e2ad9a76cd$var$_default = module.exports.default = $75a7c5e2ad9a76cd$var$EditorSettingsIcon;

});

parcelRegister("7rLeu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56bfb16f3ae85b95$var$_react = $56bfb16f3ae85b95$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $56bfb16f3ae85b95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56bfb16f3ae85b95$var$EditorTableIcon = (props)=>/*#__PURE__*/ $56bfb16f3ae85b95$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 6h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2m0 2v3h3V8zm5 0v3h3V8zm-5 5v3h3v-3zm5 0v3h3v-3z"/></svg>`
    }, props));
$56bfb16f3ae85b95$var$EditorTableIcon.displayName = 'EditorTableIcon';
var $56bfb16f3ae85b95$var$_default = module.exports.default = $56bfb16f3ae85b95$var$EditorTableIcon;

});

parcelRegister("j0spP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd640f260a916464$var$_react = $dd640f260a916464$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $dd640f260a916464$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dd640f260a916464$var$EditorTaskIcon = (props)=>/*#__PURE__*/ $dd640f260a916464$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.5 6h9A1.5 1.5 0 0 1 18 7.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6m3.072 8.838.143.154a.5.5 0 0 0 .769-.042l.13-.175 3.733-5.045a.8.8 0 0 0-.11-1.064.665.665 0 0 0-.984.118l-3.243 4.387-1.315-1.422a.663.663 0 0 0-.99 0 .8.8 0 0 0 0 1.07z"/></svg>`
    }, props));
$dd640f260a916464$var$EditorTaskIcon.displayName = 'EditorTaskIcon';
var $dd640f260a916464$var$_default = module.exports.default = $dd640f260a916464$var$EditorTaskIcon;

});

parcelRegister("45NuA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fae053470aa48fc$var$_react = $2fae053470aa48fc$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $2fae053470aa48fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2fae053470aa48fc$var$FeedbackIcon = (props)=>/*#__PURE__*/ $2fae053470aa48fc$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props));
$2fae053470aa48fc$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $2fae053470aa48fc$var$_default = module.exports.default = $2fae053470aa48fc$var$FeedbackIcon;

});

parcelRegister("cMnm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94dc15c6e18cf206$var$_react = $94dc15c6e18cf206$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $94dc15c6e18cf206$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $94dc15c6e18cf206$var$HipchatChevronDoubleDownIcon = (props)=>/*#__PURE__*/ $94dc15c6e18cf206$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m14.3 13.29-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0m0-6.01-2.31 2.33-2.3-2.32a.99.99 0 0 0-1.4 0 1.01 1.01 0 0 0 0 1.42l2.93 2.96c.21.22.49.32.77.32s.56-.11.78-.32l2.94-2.96a1.01 1.01 0 0 0 0-1.42.99.99 0 0 0-1.41 0"/></svg>`
    }, props));
$94dc15c6e18cf206$var$HipchatChevronDoubleDownIcon.displayName = 'HipchatChevronDoubleDownIcon';
var $94dc15c6e18cf206$var$_default = module.exports.default = $94dc15c6e18cf206$var$HipchatChevronDoubleDownIcon;

});

parcelRegister("k2c1s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e95d51f41af309ec$var$_react = $e95d51f41af309ec$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e95d51f41af309ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e95d51f41af309ec$var$HipchatChevronDoubleUpIcon = (props)=>/*#__PURE__*/ $e95d51f41af309ec$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.22 6.32 8.29 9.28a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0L12 8.38l2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32m0 6-2.93 2.96a1.01 1.01 0 0 0 0 1.42.99.99 0 0 0 1.41 0l2.3-2.32 2.31 2.33a.99.99 0 0 0 1.41 0 1.01 1.01 0 0 0 0-1.42l-2.94-2.96a1.1 1.1 0 0 0-.79-.33c-.28 0-.56.11-.77.32"/></svg>`
    }, props));
$e95d51f41af309ec$var$HipchatChevronDoubleUpIcon.displayName = 'HipchatChevronDoubleUpIcon';
var $e95d51f41af309ec$var$_default = module.exports.default = $e95d51f41af309ec$var$HipchatChevronDoubleUpIcon;

});

parcelRegister("lj1Sg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f82cd384519fde1f$var$_react = $f82cd384519fde1f$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $f82cd384519fde1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f82cd384519fde1f$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $f82cd384519fde1f$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props));
$f82cd384519fde1f$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $f82cd384519fde1f$var$_default = module.exports.default = $f82cd384519fde1f$var$HipchatChevronUpIcon;

});

parcelRegister("17uVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d0e70a47d35d183$var$_react = $0d0e70a47d35d183$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0d0e70a47d35d183$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0d0e70a47d35d183$var$LockFilledIcon = (props)=>/*#__PURE__*/ $0d0e70a47d35d183$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props));
$0d0e70a47d35d183$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $0d0e70a47d35d183$var$_default = module.exports.default = $0d0e70a47d35d183$var$LockFilledIcon;

});

parcelRegister("9o9gx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d5d8aed42af7260$var$_react = $6d5d8aed42af7260$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $6d5d8aed42af7260$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6d5d8aed42af7260$var$MediaServicesTextIcon = (props)=>/*#__PURE__*/ $6d5d8aed42af7260$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v11h-2zM6 5h12v2H6z"/><path d="M5 5h2v3H5zm5 13h4v2h-4zm7-13h2v3h-2z"/></g></svg>`
    }, props));
$6d5d8aed42af7260$var$MediaServicesTextIcon.displayName = 'MediaServicesTextIcon';
var $6d5d8aed42af7260$var$_default = module.exports.default = $6d5d8aed42af7260$var$MediaServicesTextIcon;

});

parcelRegister("duHPY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d3014db31e64636$var$_react = $9d3014db31e64636$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9d3014db31e64636$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d3014db31e64636$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $9d3014db31e64636$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$9d3014db31e64636$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $9d3014db31e64636$var$_default = module.exports.default = $9d3014db31e64636$var$PeopleGroupIcon;

});

parcelRegister("3Jfdd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b715fe4c11e3562$var$_react = $2b715fe4c11e3562$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $2b715fe4c11e3562$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2b715fe4c11e3562$var$PersonIcon = (props)=>/*#__PURE__*/ $2b715fe4c11e3562$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$2b715fe4c11e3562$var$PersonIcon.displayName = 'PersonIcon';
var $2b715fe4c11e3562$var$_default = module.exports.default = $2b715fe4c11e3562$var$PersonIcon;

});

parcelRegister("jPIdX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e70515bd22ba1bd2$var$_react = $e70515bd22ba1bd2$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $e70515bd22ba1bd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e70515bd22ba1bd2$var$PreferencesIcon = (props)=>/*#__PURE__*/ $e70515bd22ba1bd2$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props));
$e70515bd22ba1bd2$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $e70515bd22ba1bd2$var$_default = module.exports.default = $e70515bd22ba1bd2$var$PreferencesIcon;

});

parcelRegister("8nVd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61acd9aba8d3263b$var$_react = $61acd9aba8d3263b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $61acd9aba8d3263b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $61acd9aba8d3263b$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $61acd9aba8d3263b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props));
$61acd9aba8d3263b$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $61acd9aba8d3263b$var$_default = module.exports.default = $61acd9aba8d3263b$var$QuestionCircleIcon;

});

parcelRegister("RZ5dr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0a2455304a8709d7$var$_react = $0a2455304a8709d7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $0a2455304a8709d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a2455304a8709d7$var$RedoIcon = (props)=>/*#__PURE__*/ $0a2455304a8709d7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
    }, props));
$0a2455304a8709d7$var$RedoIcon.displayName = 'RedoIcon';
var $0a2455304a8709d7$var$_default = module.exports.default = $0a2455304a8709d7$var$RedoIcon;

});

parcelRegister("cPXGO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95888c8fcc018083$var$_react = $95888c8fcc018083$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95888c8fcc018083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95888c8fcc018083$var$SelectClearIcon = (props)=>/*#__PURE__*/ $95888c8fcc018083$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props));
$95888c8fcc018083$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $95888c8fcc018083$var$_default = module.exports.default = $95888c8fcc018083$var$SelectClearIcon;

});

parcelRegister("duwZb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d27aa028b1018ef$var$_react = $9d27aa028b1018ef$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9d27aa028b1018ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d27aa028b1018ef$var$ShipIcon = (props)=>/*#__PURE__*/ $9d27aa028b1018ef$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props));
$9d27aa028b1018ef$var$ShipIcon.displayName = 'ShipIcon';
var $9d27aa028b1018ef$var$_default = module.exports.default = $9d27aa028b1018ef$var$ShipIcon;

});

parcelRegister("8bFzt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f5f98ff58973ddb$var$_react = $5f5f98ff58973ddb$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $5f5f98ff58973ddb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5f5f98ff58973ddb$var$ShortcutIcon = (props)=>/*#__PURE__*/ $5f5f98ff58973ddb$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props));
$5f5f98ff58973ddb$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $5f5f98ff58973ddb$var$_default = module.exports.default = $5f5f98ff58973ddb$var$ShortcutIcon;

});

parcelRegister("53aPg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ad5a154046fdbb6$var$_react = $3ad5a154046fdbb6$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3ad5a154046fdbb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3ad5a154046fdbb6$var$StatusIcon = (props)=>/*#__PURE__*/ $3ad5a154046fdbb6$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4 5h16c1.105 0 2 1.045 2 2.333v9.334C22 17.955 21.105 19 20 19H4c-1.105 0-2-1.045-2-2.333V7.333C2 6.045 2.895 5 4 5m3.465 9.887h1.278L6.786 9.251H5.399l-1.957 5.636h1.183l.434-1.343h1.98zM6.02 10.423h.07l.7 2.21H5.313zm6.215 4.464c1.203 0 1.95-.625 1.95-1.613 0-.726-.544-1.289-1.29-1.344v-.07a1.22 1.22 0 0 0 1.02-1.203c0-.871-.653-1.406-1.747-1.406H9.704v5.636zm-1.352-4.734h.985c.562 0 .886.27.886.719 0 .453-.347.715-.984.715h-.887zm0 3.832v-1.601h1.024c.695 0 1.074.273 1.074.789 0 .527-.367.812-1.047.812zm6.762 1.047c1.36 0 2.352-.84 2.45-2.059h-1.15c-.112.621-.62 1.02-1.296 1.02-.89 0-1.441-.738-1.441-1.926s.55-1.922 1.437-1.922c.672 0 1.184.426 1.297 1.074h1.148c-.086-1.226-1.109-2.113-2.445-2.113-1.637 0-2.645 1.13-2.645 2.961 0 1.836 1.012 2.965 2.645 2.965"/></svg>`
    }, props));
$3ad5a154046fdbb6$var$StatusIcon.displayName = 'StatusIcon';
var $3ad5a154046fdbb6$var$_default = module.exports.default = $3ad5a154046fdbb6$var$StatusIcon;

});

parcelRegister("a73CT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75cd5ef0644a7ec9$var$_react = $75cd5ef0644a7ec9$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $75cd5ef0644a7ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $75cd5ef0644a7ec9$var$UndoIcon = (props)=>/*#__PURE__*/ $75cd5ef0644a7ec9$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props));
$75cd5ef0644a7ec9$var$UndoIcon.displayName = 'UndoIcon';
var $75cd5ef0644a7ec9$var$_default = module.exports.default = $75cd5ef0644a7ec9$var$UndoIcon;

});

parcelRegister("imvZl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d60ac8bc359dc69af27e96295d700e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5e3184d17d4694d$var$_react = $d5e3184d17d4694d$var$_interopRequireDefault((parcelRequire("42omo")));

var $d5e3184d17d4694d$var$_app = $d5e3184d17d4694d$var$_interopRequireDefault((parcelRequire("jdPfT")));

var $d5e3184d17d4694d$var$_addon = $d5e3184d17d4694d$var$_interopRequireDefault((parcelRequire("lcVFI")));
function $d5e3184d17d4694d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppIcon.
 * This component is AppIcon, with `UNSAFE_fallbackIcon` set to "AddonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5e3184d17d4694d$var$AppIcon = (props)=>/*#__PURE__*/ $d5e3184d17d4694d$var$_react.default.createElement($d5e3184d17d4694d$var$_app.default, Object.assign({
        name: "AppIcon",
        LEGACY_fallbackIcon: $d5e3184d17d4694d$var$_addon.default
    }, props));
$d5e3184d17d4694d$var$AppIcon.displayName = 'AppIconMigration';
var $d5e3184d17d4694d$var$_default = module.exports.default = $d5e3184d17d4694d$var$AppIcon;

});

parcelRegister("h5EpV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99020890135c5b25f31fb0429ba52c7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c712414f26e3f238$var$_react = $c712414f26e3f238$var$_interopRequireDefault((parcelRequire("42omo")));

var $c712414f26e3f238$var$_alignTextCenter = $c712414f26e3f238$var$_interopRequireDefault((parcelRequire("kiZiu")));

var $c712414f26e3f238$var$_alignCenter = $c712414f26e3f238$var$_interopRequireDefault((parcelRequire("lkHRD")));
function $c712414f26e3f238$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AlignTextCenterIcon.
 * This component is AlignTextCenterIcon, with `UNSAFE_fallbackIcon` set to "EditorAlignCenterIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c712414f26e3f238$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $c712414f26e3f238$var$_react.default.createElement($c712414f26e3f238$var$_alignTextCenter.default, Object.assign({
        name: "AlignTextCenterIcon",
        LEGACY_fallbackIcon: $c712414f26e3f238$var$_alignCenter.default
    }, props));
$c712414f26e3f238$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIconMigration';
var $c712414f26e3f238$var$_default = module.exports.default = $c712414f26e3f238$var$AlignTextCenterIcon;

});

parcelRegister("kiZiu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::639907b1c645e6ea80b9123cf89bed35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec8509727be230bb$var$_react = $ec8509727be230bb$var$_interopRequireDefault((parcelRequire("42omo")));

var $ec8509727be230bb$var$_baseNew = $ec8509727be230bb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ec8509727be230bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec8509727be230bb$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $ec8509727be230bb$var$_react.default.createElement($ec8509727be230bb$var$_baseNew.default, Object.assign({
        name: "AlignTextCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$ec8509727be230bb$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $ec8509727be230bb$var$_default = module.exports.default = $ec8509727be230bb$var$AlignTextCenterIcon;

});

parcelRegister("jzhw9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e5baeaa2c36dad27a8b98ef155f7a5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3eedfcfaaabf045$var$_react = $e3eedfcfaaabf045$var$_interopRequireDefault((parcelRequire("42omo")));

var $e3eedfcfaaabf045$var$_checkMark = $e3eedfcfaaabf045$var$_interopRequireDefault((parcelRequire("cvXh8")));

var $e3eedfcfaaabf045$var$_check = $e3eedfcfaaabf045$var$_interopRequireDefault((parcelRequire("66FuL")));
function $e3eedfcfaaabf045$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3eedfcfaaabf045$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $e3eedfcfaaabf045$var$_react.default.createElement($e3eedfcfaaabf045$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $e3eedfcfaaabf045$var$_check.default
    }, props));
$e3eedfcfaaabf045$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $e3eedfcfaaabf045$var$_default = module.exports.default = $e3eedfcfaaabf045$var$CheckMarkIcon;

});

parcelRegister("kiq1W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec69ae2b32a093e6$var$_react = $ec69ae2b32a093e6$var$_interopRequireDefault((parcelRequire("42omo")));

var $ec69ae2b32a093e6$var$_chevronLeft = $ec69ae2b32a093e6$var$_interopRequireDefault((parcelRequire("laHi9")));

var $ec69ae2b32a093e6$var$_chevronLeftLarge = $ec69ae2b32a093e6$var$_interopRequireDefault((parcelRequire("7jrhz")));
function $ec69ae2b32a093e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec69ae2b32a093e6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ec69ae2b32a093e6$var$_react.default.createElement($ec69ae2b32a093e6$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $ec69ae2b32a093e6$var$_chevronLeftLarge.default
    }, props));
$ec69ae2b32a093e6$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $ec69ae2b32a093e6$var$_default = module.exports.default = $ec69ae2b32a093e6$var$ChevronLeftIcon;

});

parcelRegister("laHi9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f69c1d02fec73b65$var$_react = $f69c1d02fec73b65$var$_interopRequireDefault((parcelRequire("42omo")));

var $f69c1d02fec73b65$var$_baseNew = $f69c1d02fec73b65$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f69c1d02fec73b65$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f69c1d02fec73b65$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $f69c1d02fec73b65$var$_react.default.createElement($f69c1d02fec73b65$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$f69c1d02fec73b65$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $f69c1d02fec73b65$var$_default = module.exports.default = $f69c1d02fec73b65$var$ChevronLeftIcon;

});

parcelRegister("bcA7r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9122dabf5a4e80a209ec2f5b7da6e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $827cd52fee29c31e$var$_react = $827cd52fee29c31e$var$_interopRequireDefault((parcelRequire("42omo")));

var $827cd52fee29c31e$var$_chevronUp = $827cd52fee29c31e$var$_interopRequireDefault((parcelRequire("2AytZ")));

var $827cd52fee29c31e$var$_chevronUp2 = $827cd52fee29c31e$var$_interopRequireDefault((parcelRequire("lj1Sg")));
function $827cd52fee29c31e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $827cd52fee29c31e$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $827cd52fee29c31e$var$_react.default.createElement($827cd52fee29c31e$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $827cd52fee29c31e$var$_chevronUp2.default
    }, props));
$827cd52fee29c31e$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $827cd52fee29c31e$var$_default = module.exports.default = $827cd52fee29c31e$var$ChevronUpIcon;

});

parcelRegister("2AytZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e29b122ed40dfe9$var$_react = $1e29b122ed40dfe9$var$_interopRequireDefault((parcelRequire("42omo")));

var $1e29b122ed40dfe9$var$_baseNew = $1e29b122ed40dfe9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1e29b122ed40dfe9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e29b122ed40dfe9$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $1e29b122ed40dfe9$var$_react.default.createElement($1e29b122ed40dfe9$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$1e29b122ed40dfe9$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $1e29b122ed40dfe9$var$_default = module.exports.default = $1e29b122ed40dfe9$var$ChevronUpIcon;

});

parcelRegister("eCikN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::39587b11c4986e0d712ae1453e80c830>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa42d6245de25c64$var$_react = $aa42d6245de25c64$var$_interopRequireDefault((parcelRequire("42omo")));

var $aa42d6245de25c64$var$_edit = $aa42d6245de25c64$var$_interopRequireDefault((parcelRequire("1Zr9M")));

var $aa42d6245de25c64$var$_editFilled = $aa42d6245de25c64$var$_interopRequireDefault((parcelRequire("Dlgdv")));
function $aa42d6245de25c64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aa42d6245de25c64$var$EditIcon = (props)=>/*#__PURE__*/ $aa42d6245de25c64$var$_react.default.createElement($aa42d6245de25c64$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $aa42d6245de25c64$var$_editFilled.default
    }, props));
$aa42d6245de25c64$var$EditIcon.displayName = 'EditIconMigration';
var $aa42d6245de25c64$var$_default = module.exports.default = $aa42d6245de25c64$var$EditIcon;

});

parcelRegister("chErI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14c96c4885e6c927729e770a6ffb9e6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f167248a35ac11d$var$_react = $8f167248a35ac11d$var$_interopRequireDefault((parcelRequire("42omo")));

var $8f167248a35ac11d$var$_add = $8f167248a35ac11d$var$_interopRequireDefault((parcelRequire("g5gZt")));

var $8f167248a35ac11d$var$_add2 = $8f167248a35ac11d$var$_interopRequireDefault((parcelRequire("ln6ck")));
function $8f167248a35ac11d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f167248a35ac11d$var$AddIcon = (props)=>/*#__PURE__*/ $8f167248a35ac11d$var$_react.default.createElement($8f167248a35ac11d$var$_add.default, Object.assign({
        name: "AddIcon",
        LEGACY_fallbackIcon: $8f167248a35ac11d$var$_add2.default
    }, props));
$8f167248a35ac11d$var$AddIcon.displayName = 'AddIconMigration';
var $8f167248a35ac11d$var$_default = module.exports.default = $8f167248a35ac11d$var$AddIcon;

});

parcelRegister("g5gZt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16076dcc8358b4ceed39bd4386a6c9a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb5a4aed9b7eb82f$var$_react = $bb5a4aed9b7eb82f$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb5a4aed9b7eb82f$var$_baseNew = $bb5a4aed9b7eb82f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb5a4aed9b7eb82f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb5a4aed9b7eb82f$var$AddIcon = (props)=>/*#__PURE__*/ $bb5a4aed9b7eb82f$var$_react.default.createElement($bb5a4aed9b7eb82f$var$_baseNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$bb5a4aed9b7eb82f$var$AddIcon.displayName = 'AddIcon';
var $bb5a4aed9b7eb82f$var$_default = module.exports.default = $bb5a4aed9b7eb82f$var$AddIcon;

});

parcelRegister("j4ae9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c05c142a4056afc1df3ca1d775af2e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de1652f0e02aaf7e$var$_react = $de1652f0e02aaf7e$var$_interopRequireDefault((parcelRequire("42omo")));

var $de1652f0e02aaf7e$var$_paintBucket = $de1652f0e02aaf7e$var$_interopRequireDefault((parcelRequire("7TXtV")));

var $de1652f0e02aaf7e$var$_backgroundColor = $de1652f0e02aaf7e$var$_interopRequireDefault((parcelRequire("3KXjR")));
function $de1652f0e02aaf7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de1652f0e02aaf7e$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $de1652f0e02aaf7e$var$_react.default.createElement($de1652f0e02aaf7e$var$_paintBucket.default, Object.assign({
        name: "PaintBucketIcon",
        LEGACY_fallbackIcon: $de1652f0e02aaf7e$var$_backgroundColor.default
    }, props));
$de1652f0e02aaf7e$var$PaintBucketIcon.displayName = 'PaintBucketIconMigration';
var $de1652f0e02aaf7e$var$_default = module.exports.default = $de1652f0e02aaf7e$var$PaintBucketIcon;

});

parcelRegister("7TXtV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3d1cf3fe76b67397293294a09a2816b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c0bcf406f7b5721$var$_react = $5c0bcf406f7b5721$var$_interopRequireDefault((parcelRequire("42omo")));

var $5c0bcf406f7b5721$var$_baseNew = $5c0bcf406f7b5721$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5c0bcf406f7b5721$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c0bcf406f7b5721$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $5c0bcf406f7b5721$var$_react.default.createElement($5c0bcf406f7b5721$var$_baseNew.default, Object.assign({
        name: "PaintBucketIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.616a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.336a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a17 17 0 0 0-.36.695c-.098.202-.202.43-.283.641-.068.177-.167.458-.167.717a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.717a8 8 0 0 0-.284-.641 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$5c0bcf406f7b5721$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $5c0bcf406f7b5721$var$_default = module.exports.default = $5c0bcf406f7b5721$var$PaintBucketIcon;

});

parcelRegister("l6sV5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f275adf768e9baa0bfb779f3f0533be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5d09760e7b2c783$var$_react = $f5d09760e7b2c783$var$_interopRequireDefault((parcelRequire("42omo")));

var $f5d09760e7b2c783$var$_textBold = $f5d09760e7b2c783$var$_interopRequireDefault((parcelRequire("7gIXe")));

var $f5d09760e7b2c783$var$_bold = $f5d09760e7b2c783$var$_interopRequireDefault((parcelRequire("bX0fK")));
function $f5d09760e7b2c783$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextBoldIcon.
 * This component is TextBoldIcon, with `UNSAFE_fallbackIcon` set to "EditorBoldIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5d09760e7b2c783$var$TextBoldIcon = (props)=>/*#__PURE__*/ $f5d09760e7b2c783$var$_react.default.createElement($f5d09760e7b2c783$var$_textBold.default, Object.assign({
        name: "TextBoldIcon",
        LEGACY_fallbackIcon: $f5d09760e7b2c783$var$_bold.default
    }, props));
$f5d09760e7b2c783$var$TextBoldIcon.displayName = 'TextBoldIconMigration';
var $f5d09760e7b2c783$var$_default = module.exports.default = $f5d09760e7b2c783$var$TextBoldIcon;

});

parcelRegister("7gIXe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcbd61e491a8ad12e04031cd646fdab3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54ace602f603e03d$var$_react = $54ace602f603e03d$var$_interopRequireDefault((parcelRequire("42omo")));

var $54ace602f603e03d$var$_baseNew = $54ace602f603e03d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $54ace602f603e03d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextBold".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for bolding text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54ace602f603e03d$var$TextBoldIcon = (props)=>/*#__PURE__*/ $54ace602f603e03d$var$_react.default.createElement($54ace602f603e03d$var$_baseNew.default, Object.assign({
        name: "TextBoldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.125C3 1.504 3.504 1 4.125 1H8.75C11.004 1 13 2.626 13 5.063a3.93 3.93 0 0 1-.855 2.492A3.92 3.92 0 0 1 14 10.938C14 13.374 12.004 15 9.75 15H4.125A1.125 1.125 0 0 1 3 13.875zm5.75 4.75c1.198 0 2-.798 2-1.812s-.802-1.813-2-1.813h-3.5v3.625zm-3.5 2.25h4.5c1.198 0 2 .798 2 1.813s-.802 1.812-2 1.812h-4.5z" clip-rule="evenodd"/>`
    }, props));
$54ace602f603e03d$var$TextBoldIcon.displayName = 'TextBoldIcon';
var $54ace602f603e03d$var$_default = module.exports.default = $54ace602f603e03d$var$TextBoldIcon;

});

parcelRegister("3DbzI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::18cd44b40ff8809efea24ae850576bc8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a4dfe28624f9807$var$_react = $2a4dfe28624f9807$var$_interopRequireDefault((parcelRequire("42omo")));

var $2a4dfe28624f9807$var$_cross = $2a4dfe28624f9807$var$_interopRequireDefault((parcelRequire("hmuev")));

var $2a4dfe28624f9807$var$_close = $2a4dfe28624f9807$var$_interopRequireDefault((parcelRequire("d0d2M")));
function $2a4dfe28624f9807$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a4dfe28624f9807$var$CrossIcon = (props)=>/*#__PURE__*/ $2a4dfe28624f9807$var$_react.default.createElement($2a4dfe28624f9807$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $2a4dfe28624f9807$var$_close.default
    }, props));
$2a4dfe28624f9807$var$CrossIcon.displayName = 'CrossIconMigration';
var $2a4dfe28624f9807$var$_default = module.exports.default = $2a4dfe28624f9807$var$CrossIcon;

});

parcelRegister("f4Rpb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666490f25e634884d5c2169b0cfbe1fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa0a7e2d767bf39$var$_react = $afa0a7e2d767bf39$var$_interopRequireDefault((parcelRequire("42omo")));

var $afa0a7e2d767bf39$var$_angleBrackets = $afa0a7e2d767bf39$var$_interopRequireDefault((parcelRequire("eIlE7")));

var $afa0a7e2d767bf39$var$_code = $afa0a7e2d767bf39$var$_interopRequireDefault((parcelRequire("kG2Cm")));
function $afa0a7e2d767bf39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "EditorCodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa0a7e2d767bf39$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $afa0a7e2d767bf39$var$_react.default.createElement($afa0a7e2d767bf39$var$_angleBrackets.default, Object.assign({
        name: "AngleBracketsIcon",
        LEGACY_fallbackIcon: $afa0a7e2d767bf39$var$_code.default
    }, props));
$afa0a7e2d767bf39$var$AngleBracketsIcon.displayName = 'AngleBracketsIconMigration';
var $afa0a7e2d767bf39$var$_default = module.exports.default = $afa0a7e2d767bf39$var$AngleBracketsIcon;

});

parcelRegister("eIlE7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1091d7b3916e42e9c126eb0a1ee5598a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab65f7382d80a15b$var$_react = $ab65f7382d80a15b$var$_interopRequireDefault((parcelRequire("42omo")));

var $ab65f7382d80a15b$var$_baseNew = $ab65f7382d80a15b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ab65f7382d80a15b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab65f7382d80a15b$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $ab65f7382d80a15b$var$_react.default.createElement($ab65f7382d80a15b$var$_baseNew.default, Object.assign({
        name: "AngleBracketsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$ab65f7382d80a15b$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $ab65f7382d80a15b$var$_default = module.exports.default = $ab65f7382d80a15b$var$AngleBracketsIcon;

});

parcelRegister("ehmAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebcd1de31972e031048867b7cb16b5d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6542db045223589$var$_react = $a6542db045223589$var$_interopRequireDefault((parcelRequire("42omo")));

var $a6542db045223589$var$_calendar = $a6542db045223589$var$_interopRequireDefault((parcelRequire("8DN9t")));

var $a6542db045223589$var$_date = $a6542db045223589$var$_interopRequireDefault((parcelRequire("bmrnl")));
function $a6542db045223589$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "EditorDateIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6542db045223589$var$CalendarIcon = (props)=>/*#__PURE__*/ $a6542db045223589$var$_react.default.createElement($a6542db045223589$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $a6542db045223589$var$_date.default
    }, props));
$a6542db045223589$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $a6542db045223589$var$_default = module.exports.default = $a6542db045223589$var$CalendarIcon;

});

parcelRegister("ibMH8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::09b32cb7d4442686961e5cde83b86b0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3df06d40ec50d9b$var$_react = $d3df06d40ec50d9b$var$_interopRequireDefault((parcelRequire("42omo")));

var $d3df06d40ec50d9b$var$_decision = $d3df06d40ec50d9b$var$_interopRequireDefault((parcelRequire("ejBUP")));

var $d3df06d40ec50d9b$var$_decision2 = $d3df06d40ec50d9b$var$_interopRequireDefault((parcelRequire("8JMZ0")));
function $d3df06d40ec50d9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3df06d40ec50d9b$var$DecisionIcon = (props)=>/*#__PURE__*/ $d3df06d40ec50d9b$var$_react.default.createElement($d3df06d40ec50d9b$var$_decision.default, Object.assign({
        name: "DecisionIcon",
        LEGACY_fallbackIcon: $d3df06d40ec50d9b$var$_decision2.default
    }, props));
$d3df06d40ec50d9b$var$DecisionIcon.displayName = 'DecisionIconMigration';
var $d3df06d40ec50d9b$var$_default = module.exports.default = $d3df06d40ec50d9b$var$DecisionIcon;

});

parcelRegister("ejBUP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cf6befe44e2552b8aec07f847b9be00>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6c0404d15831247$var$_react = $a6c0404d15831247$var$_interopRequireDefault((parcelRequire("42omo")));

var $a6c0404d15831247$var$_baseNew = $a6c0404d15831247$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a6c0404d15831247$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6c0404d15831247$var$DecisionIcon = (props)=>/*#__PURE__*/ $a6c0404d15831247$var$_react.default.createElement($a6c0404d15831247$var$_baseNew.default, Object.assign({
        name: "DecisionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$a6c0404d15831247$var$DecisionIcon.displayName = 'DecisionIcon';
var $a6c0404d15831247$var$_default = module.exports.default = $a6c0404d15831247$var$DecisionIcon;

});

parcelRegister("aymRb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::600b8f5df6a73844cbfa316238c6d2e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aeecf4288c2040e$var$_react = $7aeecf4288c2040e$var$_interopRequireDefault((parcelRequire("42omo")));

var $7aeecf4288c2040e$var$_checkMark = $7aeecf4288c2040e$var$_interopRequireDefault((parcelRequire("cvXh8")));

var $7aeecf4288c2040e$var$_done = $7aeecf4288c2040e$var$_interopRequireDefault((parcelRequire("6Eilg")));
function $7aeecf4288c2040e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aeecf4288c2040e$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $7aeecf4288c2040e$var$_react.default.createElement($7aeecf4288c2040e$var$_checkMark.default, Object.assign({
        name: "CheckMarkIcon",
        LEGACY_fallbackIcon: $7aeecf4288c2040e$var$_done.default
    }, props));
$7aeecf4288c2040e$var$CheckMarkIcon.displayName = 'CheckMarkIconMigration';
var $7aeecf4288c2040e$var$_default = module.exports.default = $7aeecf4288c2040e$var$CheckMarkIcon;

});

parcelRegister("4XQel", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76c3d1c8c171022a94e8d1953855fefa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $39d52ff8503741b3$var$_react = $39d52ff8503741b3$var$_interopRequireDefault((parcelRequire("42omo")));

var $39d52ff8503741b3$var$_emoji = $39d52ff8503741b3$var$_interopRequireDefault((parcelRequire("9eEg2")));

var $39d52ff8503741b3$var$_emoji2 = $39d52ff8503741b3$var$_interopRequireDefault((parcelRequire("i6rUi")));
function $39d52ff8503741b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EditorEmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $39d52ff8503741b3$var$EmojiIcon = (props)=>/*#__PURE__*/ $39d52ff8503741b3$var$_react.default.createElement($39d52ff8503741b3$var$_emoji.default, Object.assign({
        name: "EmojiIcon",
        LEGACY_fallbackIcon: $39d52ff8503741b3$var$_emoji2.default
    }, props));
$39d52ff8503741b3$var$EmojiIcon.displayName = 'EmojiIconMigration';
var $39d52ff8503741b3$var$_default = module.exports.default = $39d52ff8503741b3$var$EmojiIcon;

});

parcelRegister("5R9Iq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d381176fa9099a02b2db34f93c306f2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44397050c41a0bd8$var$_react = $44397050c41a0bd8$var$_interopRequireDefault((parcelRequire("42omo")));

var $44397050c41a0bd8$var$_crossCircle = $44397050c41a0bd8$var$_interopRequireDefault((parcelRequire("7yDmn")));

var $44397050c41a0bd8$var$_error = $44397050c41a0bd8$var$_interopRequireDefault((parcelRequire("dOtw2")));
function $44397050c41a0bd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "EditorErrorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44397050c41a0bd8$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $44397050c41a0bd8$var$_react.default.createElement($44397050c41a0bd8$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $44397050c41a0bd8$var$_error.default
    }, props));
$44397050c41a0bd8$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $44397050c41a0bd8$var$_default = module.exports.default = $44397050c41a0bd8$var$CrossCircleIcon;

});

parcelRegister("7yDmn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $580a3d6d99b490e5$var$_react = $580a3d6d99b490e5$var$_interopRequireDefault((parcelRequire("42omo")));

var $580a3d6d99b490e5$var$_baseNew = $580a3d6d99b490e5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $580a3d6d99b490e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $580a3d6d99b490e5$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $580a3d6d99b490e5$var$_react.default.createElement($580a3d6d99b490e5$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$580a3d6d99b490e5$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $580a3d6d99b490e5$var$_default = module.exports.default = $580a3d6d99b490e5$var$CrossCircleIcon;

});

parcelRegister("jfOH7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43e098af61abd467f677e517361d7166>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e046bde8f1113ac2$var$_react = $e046bde8f1113ac2$var$_interopRequireDefault((parcelRequire("42omo")));

var $e046bde8f1113ac2$var$_growHorizontal = $e046bde8f1113ac2$var$_interopRequireDefault((parcelRequire("1kVeP")));

var $e046bde8f1113ac2$var$_expand = $e046bde8f1113ac2$var$_interopRequireDefault((parcelRequire("inR50")));
function $e046bde8f1113ac2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowHorizontalIcon.
 * This component is GrowHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e046bde8f1113ac2$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $e046bde8f1113ac2$var$_react.default.createElement($e046bde8f1113ac2$var$_growHorizontal.default, Object.assign({
        name: "GrowHorizontalIcon",
        LEGACY_fallbackIcon: $e046bde8f1113ac2$var$_expand.default
    }, props));
$e046bde8f1113ac2$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIconMigration';
var $e046bde8f1113ac2$var$_default = module.exports.default = $e046bde8f1113ac2$var$GrowHorizontalIcon;

});

parcelRegister("c8Les", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afc2a06d02cd5de17b8369ab9ec2ebf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d6adebba12b9893$var$_react = $8d6adebba12b9893$var$_interopRequireDefault((parcelRequire("42omo")));

var $8d6adebba12b9893$var$_minus = $8d6adebba12b9893$var$_interopRequireDefault((parcelRequire("5Yp2m")));

var $8d6adebba12b9893$var$_horizontalRule = $8d6adebba12b9893$var$_interopRequireDefault((parcelRequire("5b9Z9")));
function $8d6adebba12b9893$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MinusIcon.
 * This component is MinusIcon, with `UNSAFE_fallbackIcon` set to "EditorHorizontalRuleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d6adebba12b9893$var$MinusIcon = (props)=>/*#__PURE__*/ $8d6adebba12b9893$var$_react.default.createElement($8d6adebba12b9893$var$_minus.default, Object.assign({
        name: "MinusIcon",
        LEGACY_fallbackIcon: $8d6adebba12b9893$var$_horizontalRule.default
    }, props));
$8d6adebba12b9893$var$MinusIcon.displayName = 'MinusIconMigration';
var $8d6adebba12b9893$var$_default = module.exports.default = $8d6adebba12b9893$var$MinusIcon;

});

parcelRegister("ctKFx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b781ae7916da76ce23508b640931263>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $915c64f6fd0c2ab2$var$_react = $915c64f6fd0c2ab2$var$_interopRequireDefault((parcelRequire("42omo")));

var $915c64f6fd0c2ab2$var$_textIndentRight = $915c64f6fd0c2ab2$var$_interopRequireDefault((parcelRequire("ay6wY")));

var $915c64f6fd0c2ab2$var$_indent = $915c64f6fd0c2ab2$var$_interopRequireDefault((parcelRequire("cDCCl")));
function $915c64f6fd0c2ab2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextIndentRightIcon.
 * This component is TextIndentRightIcon, with `UNSAFE_fallbackIcon` set to "EditorIndentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $915c64f6fd0c2ab2$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $915c64f6fd0c2ab2$var$_react.default.createElement($915c64f6fd0c2ab2$var$_textIndentRight.default, Object.assign({
        name: "TextIndentRightIcon",
        LEGACY_fallbackIcon: $915c64f6fd0c2ab2$var$_indent.default
    }, props));
$915c64f6fd0c2ab2$var$TextIndentRightIcon.displayName = 'TextIndentRightIconMigration';
var $915c64f6fd0c2ab2$var$_default = module.exports.default = $915c64f6fd0c2ab2$var$TextIndentRightIcon;

});

parcelRegister("ay6wY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec56d53f6935139bc9b8387adf31e631>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ae2253f9e7df79f$var$_react = $7ae2253f9e7df79f$var$_interopRequireDefault((parcelRequire("42omo")));

var $7ae2253f9e7df79f$var$_baseNew = $7ae2253f9e7df79f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7ae2253f9e7df79f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIndentRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ae2253f9e7df79f$var$TextIndentRightIcon = (props)=>/*#__PURE__*/ $7ae2253f9e7df79f$var$_react.default.createElement($7ae2253f9e7df79f$var$_baseNew.default, Object.assign({
        name: "TextIndentRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zM2.03 4.72l2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L3.19 8 .97 5.78zM15 6.667H8v-1.5h7zm0 4.166H8v-1.5h7zm0 2.667V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$7ae2253f9e7df79f$var$TextIndentRightIcon.displayName = 'TextIndentRightIcon';
var $7ae2253f9e7df79f$var$_default = module.exports.default = $7ae2253f9e7df79f$var$TextIndentRightIcon;

});

parcelRegister("btnxO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f63bc5877ceef7abf243a0cb010fc1b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a4aa9496ca2a46$var$_react = $85a4aa9496ca2a46$var$_interopRequireDefault((parcelRequire("42omo")));

var $85a4aa9496ca2a46$var$_statusInformation = $85a4aa9496ca2a46$var$_interopRequireDefault((parcelRequire("eXmBZ")));

var $85a4aa9496ca2a46$var$_info = $85a4aa9496ca2a46$var$_interopRequireDefault((parcelRequire("4NIhb")));
function $85a4aa9496ca2a46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorInfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a4aa9496ca2a46$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $85a4aa9496ca2a46$var$_react.default.createElement($85a4aa9496ca2a46$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $85a4aa9496ca2a46$var$_info.default
    }, props));
$85a4aa9496ca2a46$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $85a4aa9496ca2a46$var$_default = module.exports.default = $85a4aa9496ca2a46$var$StatusInformationIcon;

});

parcelRegister("eXmBZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae381d98e01f3917$var$_react = $ae381d98e01f3917$var$_interopRequireDefault((parcelRequire("42omo")));

var $ae381d98e01f3917$var$_baseNew = $ae381d98e01f3917$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ae381d98e01f3917$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae381d98e01f3917$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $ae381d98e01f3917$var$_react.default.createElement($ae381d98e01f3917$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$ae381d98e01f3917$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $ae381d98e01f3917$var$_default = module.exports.default = $ae381d98e01f3917$var$StatusInformationIcon;

});

parcelRegister("gFlPH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0169ce61ed5513ac59fc09e877e7d5d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0321923685976d8f$var$_react = $0321923685976d8f$var$_interopRequireDefault((parcelRequire("42omo")));

var $0321923685976d8f$var$_layoutThreeColumns = $0321923685976d8f$var$_interopRequireDefault((parcelRequire("f22ZH")));

var $0321923685976d8f$var$_layoutThreeEqual = $0321923685976d8f$var$_interopRequireDefault((parcelRequire("lS9G7")));
function $0321923685976d8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutThreeColumnsIcon.
 * This component is LayoutThreeColumnsIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutThreeEqualIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0321923685976d8f$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $0321923685976d8f$var$_react.default.createElement($0321923685976d8f$var$_layoutThreeColumns.default, Object.assign({
        name: "LayoutThreeColumnsIcon",
        LEGACY_fallbackIcon: $0321923685976d8f$var$_layoutThreeEqual.default
    }, props));
$0321923685976d8f$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIconMigration';
var $0321923685976d8f$var$_default = module.exports.default = $0321923685976d8f$var$LayoutThreeColumnsIcon;

});

parcelRegister("6W8H3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33ad64019fdd6e67f98b45b4c1bb4baf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50cee732f79b9d94$var$_react = $50cee732f79b9d94$var$_interopRequireDefault((parcelRequire("42omo")));

var $50cee732f79b9d94$var$_layoutTwoColumnsSidebarRight = $50cee732f79b9d94$var$_interopRequireDefault((parcelRequire("dIYpm")));

var $50cee732f79b9d94$var$_layoutTwoRightSidebar = $50cee732f79b9d94$var$_interopRequireDefault((parcelRequire("7sUdD")));
function $50cee732f79b9d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LayoutTwoColumnsSidebarRightIcon.
 * This component is LayoutTwoColumnsSidebarRightIcon, with `UNSAFE_fallbackIcon` set to "EditorLayoutTwoRightSidebarIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50cee732f79b9d94$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $50cee732f79b9d94$var$_react.default.createElement($50cee732f79b9d94$var$_layoutTwoColumnsSidebarRight.default, Object.assign({
        name: "LayoutTwoColumnsSidebarRightIcon",
        LEGACY_fallbackIcon: $50cee732f79b9d94$var$_layoutTwoRightSidebar.default
    }, props));
$50cee732f79b9d94$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIconMigration';
var $50cee732f79b9d94$var$_default = module.exports.default = $50cee732f79b9d94$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("dIYpm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21c9605a2f003c9e026fcf64186def5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fde3e36c1758d05$var$_react = $9fde3e36c1758d05$var$_interopRequireDefault((parcelRequire("42omo")));

var $9fde3e36c1758d05$var$_baseNew = $9fde3e36c1758d05$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9fde3e36c1758d05$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9fde3e36c1758d05$var$LayoutTwoColumnsSidebarRightIcon = (props)=>/*#__PURE__*/ $9fde3e36c1758d05$var$_react.default.createElement($9fde3e36c1758d05$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h7.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-7.75C.615 15 0 14.384 0 13.625zm1.5.125v11H9v-11zM12 2.375C12 1.615 12.616 1 13.375 1h1.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1v-11z" clip-rule="evenodd"/>`
    }, props));
$9fde3e36c1758d05$var$LayoutTwoColumnsSidebarRightIcon.displayName = 'LayoutTwoColumnsSidebarRightIcon';
var $9fde3e36c1758d05$var$_default = module.exports.default = $9fde3e36c1758d05$var$LayoutTwoColumnsSidebarRightIcon;

});

parcelRegister("5l8Gz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f17721ea8582c4f15777a32fa3d6d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e35a6b481305f8d$var$_react = $3e35a6b481305f8d$var$_interopRequireDefault((parcelRequire("42omo")));

var $3e35a6b481305f8d$var$_link = $3e35a6b481305f8d$var$_interopRequireDefault((parcelRequire("1bY7o")));

var $3e35a6b481305f8d$var$_link2 = $3e35a6b481305f8d$var$_interopRequireDefault((parcelRequire("8IxMf")));
function $3e35a6b481305f8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e35a6b481305f8d$var$LinkIcon = (props)=>/*#__PURE__*/ $3e35a6b481305f8d$var$_react.default.createElement($3e35a6b481305f8d$var$_link.default, Object.assign({
        name: "LinkIcon",
        LEGACY_fallbackIcon: $3e35a6b481305f8d$var$_link2.default
    }, props));
$3e35a6b481305f8d$var$LinkIcon.displayName = 'LinkIconMigration';
var $3e35a6b481305f8d$var$_default = module.exports.default = $3e35a6b481305f8d$var$LinkIcon;

});

parcelRegister("9pWzB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3fc51bb51ce6dba844d651a03b45347>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6db3e248a2d96698$var$_react = $6db3e248a2d96698$var$_interopRequireDefault((parcelRequire("42omo")));

var $6db3e248a2d96698$var$_mention = $6db3e248a2d96698$var$_interopRequireDefault((parcelRequire("b4wUN")));

var $6db3e248a2d96698$var$_mention2 = $6db3e248a2d96698$var$_interopRequireDefault((parcelRequire("aBZC5")));
function $6db3e248a2d96698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6db3e248a2d96698$var$MentionIcon = (props)=>/*#__PURE__*/ $6db3e248a2d96698$var$_react.default.createElement($6db3e248a2d96698$var$_mention.default, Object.assign({
        name: "MentionIcon",
        LEGACY_fallbackIcon: $6db3e248a2d96698$var$_mention2.default
    }, props));
$6db3e248a2d96698$var$MentionIcon.displayName = 'MentionIconMigration';
var $6db3e248a2d96698$var$_default = module.exports.default = $6db3e248a2d96698$var$MentionIcon;

});

parcelRegister("b4wUN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::091705eae2c62b0ec5df7f32c6cbaf31>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80f999abfc9d3661$var$_react = $80f999abfc9d3661$var$_interopRequireDefault((parcelRequire("42omo")));

var $80f999abfc9d3661$var$_baseNew = $80f999abfc9d3661$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $80f999abfc9d3661$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80f999abfc9d3661$var$MentionIcon = (props)=>/*#__PURE__*/ $80f999abfc9d3661$var$_react.default.createElement($80f999abfc9d3661$var$_baseNew.default, Object.assign({
        name: "MentionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$80f999abfc9d3661$var$MentionIcon.displayName = 'MentionIcon';
var $80f999abfc9d3661$var$_default = module.exports.default = $80f999abfc9d3661$var$MentionIcon;

});

parcelRegister("2wS8M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::991b79665438b5f4c7ce06548b7c55db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d78911d70937ada$var$_react = $1d78911d70937ada$var$_interopRequireDefault((parcelRequire("42omo")));

var $1d78911d70937ada$var$_showMoreHorizontal = $1d78911d70937ada$var$_interopRequireDefault((parcelRequire("9VJDA")));

var $1d78911d70937ada$var$_more = $1d78911d70937ada$var$_interopRequireDefault((parcelRequire("buUDP")));
function $1d78911d70937ada$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d78911d70937ada$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $1d78911d70937ada$var$_react.default.createElement($1d78911d70937ada$var$_showMoreHorizontal.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        LEGACY_fallbackIcon: $1d78911d70937ada$var$_more.default
    }, props));
$1d78911d70937ada$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIconMigration';
var $1d78911d70937ada$var$_default = module.exports.default = $1d78911d70937ada$var$ShowMoreHorizontalIcon;

});

parcelRegister("9VJDA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73acd698654dca8f$var$_react = $73acd698654dca8f$var$_interopRequireDefault((parcelRequire("42omo")));

var $73acd698654dca8f$var$_baseNew = $73acd698654dca8f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $73acd698654dca8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73acd698654dca8f$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $73acd698654dca8f$var$_react.default.createElement($73acd698654dca8f$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$73acd698654dca8f$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $73acd698654dca8f$var$_default = module.exports.default = $73acd698654dca8f$var$ShowMoreHorizontalIcon;

});

parcelRegister("sBHk4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $055fdba0eb295b3a$var$_react = $055fdba0eb295b3a$var$_interopRequireDefault((parcelRequire("42omo")));

var $055fdba0eb295b3a$var$_discovery = $055fdba0eb295b3a$var$_interopRequireDefault((parcelRequire("4jUBz")));

var $055fdba0eb295b3a$var$_note = $055fdba0eb295b3a$var$_interopRequireDefault((parcelRequire("4ODVn")));
function $055fdba0eb295b3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $055fdba0eb295b3a$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $055fdba0eb295b3a$var$_react.default.createElement($055fdba0eb295b3a$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $055fdba0eb295b3a$var$_note.default
    }, props));
$055fdba0eb295b3a$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $055fdba0eb295b3a$var$_default = module.exports.default = $055fdba0eb295b3a$var$DiscoveryIcon;

});

parcelRegister("aAUnB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4ab52fe73f2788cd5bc16868806adf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b68fffbbcb98ebe$var$_react = $7b68fffbbcb98ebe$var$_interopRequireDefault((parcelRequire("42omo")));

var $7b68fffbbcb98ebe$var$_textIndentLeft = $7b68fffbbcb98ebe$var$_interopRequireDefault((parcelRequire("dRLbl")));

var $7b68fffbbcb98ebe$var$_outdent = $7b68fffbbcb98ebe$var$_interopRequireDefault((parcelRequire("cSfLu")));
function $7b68fffbbcb98ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextIndentLeftIcon.
 * This component is TextIndentLeftIcon, with `UNSAFE_fallbackIcon` set to "EditorOutdentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shifting the indent of text content left.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b68fffbbcb98ebe$var$TextIndentLeftIcon = (props)=>/*#__PURE__*/ $7b68fffbbcb98ebe$var$_react.default.createElement($7b68fffbbcb98ebe$var$_textIndentLeft.default, Object.assign({
        name: "TextIndentLeftIcon",
        LEGACY_fallbackIcon: $7b68fffbbcb98ebe$var$_outdent.default
    }, props));
$7b68fffbbcb98ebe$var$TextIndentLeftIcon.displayName = 'TextIndentLeftIconMigration';
var $7b68fffbbcb98ebe$var$_default = module.exports.default = $7b68fffbbcb98ebe$var$TextIndentLeftIcon;

});

parcelRegister("adWKh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7718afe6e15fd5c2$var$_react = $7718afe6e15fd5c2$var$_interopRequireDefault((parcelRequire("42omo")));

var $7718afe6e15fd5c2$var$_statusSuccess = $7718afe6e15fd5c2$var$_interopRequireDefault((parcelRequire("3sFtD")));

var $7718afe6e15fd5c2$var$_success = $7718afe6e15fd5c2$var$_interopRequireDefault((parcelRequire("6alL7")));
function $7718afe6e15fd5c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7718afe6e15fd5c2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $7718afe6e15fd5c2$var$_react.default.createElement($7718afe6e15fd5c2$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $7718afe6e15fd5c2$var$_success.default
    }, props));
$7718afe6e15fd5c2$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $7718afe6e15fd5c2$var$_default = module.exports.default = $7718afe6e15fd5c2$var$StatusSuccessIcon;

});

parcelRegister("3sFtD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28542916539b8f59$var$_react = $28542916539b8f59$var$_interopRequireDefault((parcelRequire("42omo")));

var $28542916539b8f59$var$_baseNew = $28542916539b8f59$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28542916539b8f59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28542916539b8f59$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $28542916539b8f59$var$_react.default.createElement($28542916539b8f59$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$28542916539b8f59$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $28542916539b8f59$var$_default = module.exports.default = $28542916539b8f59$var$StatusSuccessIcon;

});

parcelRegister("8srHq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca341356ec7e14a1634869a278921cc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62866ccb9c7c1589$var$_react = $62866ccb9c7c1589$var$_interopRequireDefault((parcelRequire("42omo")));

var $62866ccb9c7c1589$var$_grid = $62866ccb9c7c1589$var$_interopRequireDefault((parcelRequire("dk0le")));

var $62866ccb9c7c1589$var$_table = $62866ccb9c7c1589$var$_interopRequireDefault((parcelRequire("7rLeu")));
function $62866ccb9c7c1589$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GridIcon.
 * This component is GridIcon, with `UNSAFE_fallbackIcon` set to "EditorTableIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62866ccb9c7c1589$var$GridIcon = (props)=>/*#__PURE__*/ $62866ccb9c7c1589$var$_react.default.createElement($62866ccb9c7c1589$var$_grid.default, Object.assign({
        name: "GridIcon",
        LEGACY_fallbackIcon: $62866ccb9c7c1589$var$_table.default
    }, props));
$62866ccb9c7c1589$var$GridIcon.displayName = 'GridIconMigration';
var $62866ccb9c7c1589$var$_default = module.exports.default = $62866ccb9c7c1589$var$GridIcon;

});

parcelRegister("ktVXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31e9976e5428e0538fb0617079a259be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee9378cbc7096c55$var$_react = $ee9378cbc7096c55$var$_interopRequireDefault((parcelRequire("42omo")));

var $ee9378cbc7096c55$var$_textStyle = $ee9378cbc7096c55$var$_interopRequireDefault((parcelRequire("5gydP")));

var $ee9378cbc7096c55$var$_keyboard = $ee9378cbc7096c55$var$_interopRequireDefault((parcelRequire("kcmYy")));
function $ee9378cbc7096c55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TextStyleIcon.
 * This component is TextStyleIcon, with `UNSAFE_fallbackIcon` set to "EmojiKeyboardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee9378cbc7096c55$var$TextStyleIcon = (props)=>/*#__PURE__*/ $ee9378cbc7096c55$var$_react.default.createElement($ee9378cbc7096c55$var$_textStyle.default, Object.assign({
        name: "TextStyleIcon",
        LEGACY_fallbackIcon: $ee9378cbc7096c55$var$_keyboard.default
    }, props));
$ee9378cbc7096c55$var$TextStyleIcon.displayName = 'TextStyleIconMigration';
var $ee9378cbc7096c55$var$_default = module.exports.default = $ee9378cbc7096c55$var$TextStyleIcon;

});

parcelRegister("lVBH4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff6c290b9be38546$var$_react = $ff6c290b9be38546$var$_interopRequireDefault((parcelRequire("42omo")));

var $ff6c290b9be38546$var$_statusInformation = $ff6c290b9be38546$var$_interopRequireDefault((parcelRequire("eXmBZ")));

var $ff6c290b9be38546$var$_info = $ff6c290b9be38546$var$_interopRequireDefault((parcelRequire("a7lwr")));
function $ff6c290b9be38546$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff6c290b9be38546$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $ff6c290b9be38546$var$_react.default.createElement($ff6c290b9be38546$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $ff6c290b9be38546$var$_info.default
    }, props));
$ff6c290b9be38546$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $ff6c290b9be38546$var$_default = module.exports.default = $ff6c290b9be38546$var$StatusInformationIcon;

});

parcelRegister("am4ic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4086e75332955510ed2f144ae74452d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $789f49dd01395bf7$var$_react = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("42omo")));

var $789f49dd01395bf7$var$_quotationMark = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("9RVmI")));

var $789f49dd01395bf7$var$_quote = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("h0sHG")));
function $789f49dd01395bf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $789f49dd01395bf7$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $789f49dd01395bf7$var$_react.default.createElement($789f49dd01395bf7$var$_quotationMark.default, Object.assign({
        name: "QuotationMarkIcon",
        LEGACY_fallbackIcon: $789f49dd01395bf7$var$_quote.default
    }, props));
$789f49dd01395bf7$var$QuotationMarkIcon.displayName = 'QuotationMarkIconMigration';
var $789f49dd01395bf7$var$_default = module.exports.default = $789f49dd01395bf7$var$QuotationMarkIcon;

});

parcelRegister("9RVmI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b5ace82dd4a8965510da799b9153030>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72f58fdd2c192cd5$var$_react = $72f58fdd2c192cd5$var$_interopRequireDefault((parcelRequire("42omo")));

var $72f58fdd2c192cd5$var$_baseNew = $72f58fdd2c192cd5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $72f58fdd2c192cd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72f58fdd2c192cd5$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $72f58fdd2c192cd5$var$_react.default.createElement($72f58fdd2c192cd5$var$_baseNew.default, Object.assign({
        name: "QuotationMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$72f58fdd2c192cd5$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $72f58fdd2c192cd5$var$_default = module.exports.default = $72f58fdd2c192cd5$var$QuotationMarkIcon;

});

parcelRegister("bTSBD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0234a675d9b1e030b7622cea0db1767>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a9f30668dee786d$var$_react = $8a9f30668dee786d$var$_interopRequireDefault((parcelRequire("42omo")));

var $8a9f30668dee786d$var$_release = $8a9f30668dee786d$var$_interopRequireDefault((parcelRequire("5j8et")));

var $8a9f30668dee786d$var$_ship = $8a9f30668dee786d$var$_interopRequireDefault((parcelRequire("duwZb")));
function $8a9f30668dee786d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a9f30668dee786d$var$ReleaseIcon = (props)=>/*#__PURE__*/ $8a9f30668dee786d$var$_react.default.createElement($8a9f30668dee786d$var$_release.default, Object.assign({
        name: "ReleaseIcon",
        LEGACY_fallbackIcon: $8a9f30668dee786d$var$_ship.default
    }, props));
$8a9f30668dee786d$var$ReleaseIcon.displayName = 'ReleaseIconMigration';
var $8a9f30668dee786d$var$_default = module.exports.default = $8a9f30668dee786d$var$ReleaseIcon;

});

parcelRegister("bP2lm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::166c54eac565624de39efb8836e98193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89b6467b10c1314e$var$_react = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("42omo")));

var $89b6467b10c1314e$var$_linkExternal = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("8tdj3")));

var $89b6467b10c1314e$var$_shortcut = $89b6467b10c1314e$var$_interopRequireDefault((parcelRequire("8bFzt")));
function $89b6467b10c1314e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89b6467b10c1314e$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $89b6467b10c1314e$var$_react.default.createElement($89b6467b10c1314e$var$_linkExternal.default, Object.assign({
        name: "LinkExternalIcon",
        LEGACY_fallbackIcon: $89b6467b10c1314e$var$_shortcut.default
    }, props));
$89b6467b10c1314e$var$LinkExternalIcon.displayName = 'LinkExternalIconMigration';
var $89b6467b10c1314e$var$_default = module.exports.default = $89b6467b10c1314e$var$LinkExternalIcon;

});

parcelRegister("5MACL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435dd846dd233e32$var$_react = $435dd846dd233e32$var$_interopRequireDefault((parcelRequire("42omo")));

var $435dd846dd233e32$var$_statusWarning = $435dd846dd233e32$var$_interopRequireDefault((parcelRequire("ebrpi")));

var $435dd846dd233e32$var$_warning = $435dd846dd233e32$var$_interopRequireDefault((parcelRequire("5Xi9J")));
function $435dd846dd233e32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435dd846dd233e32$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $435dd846dd233e32$var$_react.default.createElement($435dd846dd233e32$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $435dd846dd233e32$var$_warning.default
    }, props));
$435dd846dd233e32$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $435dd846dd233e32$var$_default = module.exports.default = $435dd846dd233e32$var$StatusWarningIcon;

});

parcelRegister("4xFCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::623d8d812f68b82c75934954aaa0533d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34ea878fb2ab2fc2$var$_react = $34ea878fb2ab2fc2$var$_interopRequireDefault((parcelRequire("42omo")));

var $34ea878fb2ab2fc2$var$_add = $34ea878fb2ab2fc2$var$_interopRequireDefault((parcelRequire("g5gZt")));

var $34ea878fb2ab2fc2$var$_add2 = $34ea878fb2ab2fc2$var$_interopRequireDefault((parcelRequire("5Gq9J")));
function $34ea878fb2ab2fc2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34ea878fb2ab2fc2$var$AddIcon = (props)=>/*#__PURE__*/ $34ea878fb2ab2fc2$var$_react.default.createElement($34ea878fb2ab2fc2$var$_add.default, Object.assign({
        name: "AddIcon",
        LEGACY_fallbackIcon: $34ea878fb2ab2fc2$var$_add2.default
    }, props));
$34ea878fb2ab2fc2$var$AddIcon.displayName = 'AddIconMigration';
var $34ea878fb2ab2fc2$var$_default = module.exports.default = $34ea878fb2ab2fc2$var$AddIcon;

});

parcelRegister("9RVYh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e82594be434237a3254dda0015850bff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72f6082bdfa00caa$var$_react = $72f6082bdfa00caa$var$_interopRequireDefault((parcelRequire("42omo")));

var $72f6082bdfa00caa$var$_calendar = $72f6082bdfa00caa$var$_interopRequireDefault((parcelRequire("8DN9t")));

var $72f6082bdfa00caa$var$_calendar2 = $72f6082bdfa00caa$var$_interopRequireDefault((parcelRequire("32wsW")));
function $72f6082bdfa00caa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72f6082bdfa00caa$var$CalendarIcon = (props)=>/*#__PURE__*/ $72f6082bdfa00caa$var$_react.default.createElement($72f6082bdfa00caa$var$_calendar.default, Object.assign({
        name: "CalendarIcon",
        LEGACY_fallbackIcon: $72f6082bdfa00caa$var$_calendar2.default
    }, props));
$72f6082bdfa00caa$var$CalendarIcon.displayName = 'CalendarIconMigration';
var $72f6082bdfa00caa$var$_default = module.exports.default = $72f6082bdfa00caa$var$CalendarIcon;

});

parcelRegister("15HFc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22c67ae37e737f127366f67bd91f64bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0cb820c2d4b72997$var$_react = $0cb820c2d4b72997$var$_interopRequireDefault((parcelRequire("42omo")));

var $0cb820c2d4b72997$var$_chevronRight = $0cb820c2d4b72997$var$_interopRequireDefault((parcelRequire("6R5uz")));

var $0cb820c2d4b72997$var$_chevronRight2 = $0cb820c2d4b72997$var$_interopRequireDefault((parcelRequire("k1A8C")));
function $0cb820c2d4b72997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0cb820c2d4b72997$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0cb820c2d4b72997$var$_react.default.createElement($0cb820c2d4b72997$var$_chevronRight.default, Object.assign({
        name: "ChevronRightIcon",
        LEGACY_fallbackIcon: $0cb820c2d4b72997$var$_chevronRight2.default
    }, props));
$0cb820c2d4b72997$var$ChevronRightIcon.displayName = 'ChevronRightIconMigration';
var $0cb820c2d4b72997$var$_default = module.exports.default = $0cb820c2d4b72997$var$ChevronRightIcon;

});

parcelRegister("6R5uz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0149bdbd8af129cd$var$_react = $0149bdbd8af129cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $0149bdbd8af129cd$var$_baseNew = $0149bdbd8af129cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0149bdbd8af129cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0149bdbd8af129cd$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0149bdbd8af129cd$var$_react.default.createElement($0149bdbd8af129cd$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$0149bdbd8af129cd$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $0149bdbd8af129cd$var$_default = module.exports.default = $0149bdbd8af129cd$var$ChevronRightIcon;

});

parcelRegister("gt9HV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd6e27f4d033cc6$var$_react = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("42omo")));

var $bfd6e27f4d033cc6$var$_copy = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("2MuFw")));

var $bfd6e27f4d033cc6$var$_copy2 = $bfd6e27f4d033cc6$var$_interopRequireDefault((parcelRequire("5mdwm")));
function $bfd6e27f4d033cc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfd6e27f4d033cc6$var$CopyIcon = (props)=>/*#__PURE__*/ $bfd6e27f4d033cc6$var$_react.default.createElement($bfd6e27f4d033cc6$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $bfd6e27f4d033cc6$var$_copy2.default
    }, props));
$bfd6e27f4d033cc6$var$CopyIcon.displayName = 'CopyIconMigration';
var $bfd6e27f4d033cc6$var$_default = module.exports.default = $bfd6e27f4d033cc6$var$CopyIcon;

});

parcelRegister("2MuFw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d46d77f8084efb8562fee77ec5d30fd2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2067daa476a75158$var$_react = $2067daa476a75158$var$_interopRequireDefault((parcelRequire("42omo")));

var $2067daa476a75158$var$_baseNew = $2067daa476a75158$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2067daa476a75158$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2067daa476a75158$var$CopyIcon = (props)=>/*#__PURE__*/ $2067daa476a75158$var$_react.default.createElement($2067daa476a75158$var$_baseNew.default, Object.assign({
        name: "CopyIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$2067daa476a75158$var$CopyIcon.displayName = 'CopyIcon';
var $2067daa476a75158$var$_default = module.exports.default = $2067daa476a75158$var$CopyIcon;

});

parcelRegister("7rrdI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c27208d6ab6791006597f11ce02c72b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56b02b60aaf54197$var$_react = $56b02b60aaf54197$var$_interopRequireDefault((parcelRequire("42omo")));

var $56b02b60aaf54197$var$_download = $56b02b60aaf54197$var$_interopRequireDefault((parcelRequire("9aGns")));

var $56b02b60aaf54197$var$_download2 = $56b02b60aaf54197$var$_interopRequireDefault((parcelRequire("3UCaN")));
function $56b02b60aaf54197$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56b02b60aaf54197$var$DownloadIcon = (props)=>/*#__PURE__*/ $56b02b60aaf54197$var$_react.default.createElement($56b02b60aaf54197$var$_download.default, Object.assign({
        name: "DownloadIcon",
        LEGACY_fallbackIcon: $56b02b60aaf54197$var$_download2.default
    }, props));
$56b02b60aaf54197$var$DownloadIcon.displayName = 'DownloadIconMigration';
var $56b02b60aaf54197$var$_default = module.exports.default = $56b02b60aaf54197$var$DownloadIcon;

});

parcelRegister("3QhJU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5f964c14b35b4c00537c8ae369245e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc3fd1be6624b0b$var$_react = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("42omo")));

var $2cc3fd1be6624b0b$var$_edit = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("1Zr9M")));

var $2cc3fd1be6624b0b$var$_edit2 = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("1Nklh")));
function $2cc3fd1be6624b0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc3fd1be6624b0b$var$EditIcon = (props)=>/*#__PURE__*/ $2cc3fd1be6624b0b$var$_react.default.createElement($2cc3fd1be6624b0b$var$_edit.default, Object.assign({
        name: "EditIcon",
        LEGACY_fallbackIcon: $2cc3fd1be6624b0b$var$_edit2.default
    }, props));
$2cc3fd1be6624b0b$var$EditIcon.displayName = 'EditIconMigration';
var $2cc3fd1be6624b0b$var$_default = module.exports.default = $2cc3fd1be6624b0b$var$EditIcon;

});

parcelRegister("4NVxh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29971dcd1e1cc09403d75aea4f4ed622>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37f85e6bb62055ce$var$_react = $37f85e6bb62055ce$var$_interopRequireDefault((parcelRequire("42omo")));

var $37f85e6bb62055ce$var$_person = $37f85e6bb62055ce$var$_interopRequireDefault((parcelRequire("6767u")));

var $37f85e6bb62055ce$var$_person2 = $37f85e6bb62055ce$var$_interopRequireDefault((parcelRequire("3Jfdd")));
function $37f85e6bb62055ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37f85e6bb62055ce$var$PersonIcon = (props)=>/*#__PURE__*/ $37f85e6bb62055ce$var$_react.default.createElement($37f85e6bb62055ce$var$_person.default, Object.assign({
        name: "PersonIcon",
        LEGACY_fallbackIcon: $37f85e6bb62055ce$var$_person2.default
    }, props));
$37f85e6bb62055ce$var$PersonIcon.displayName = 'PersonIconMigration';
var $37f85e6bb62055ce$var$_default = module.exports.default = $37f85e6bb62055ce$var$PersonIcon;

});

parcelRegister("195qZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c47233d9edbba3b204e8a396289dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d5ad8d603a22871$var$_react = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("42omo")));

var $0d5ad8d603a22871$var$_questionCircle = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("ci7Ox")));

var $0d5ad8d603a22871$var$_questionCircle2 = $0d5ad8d603a22871$var$_interopRequireDefault((parcelRequire("8nVd9")));
function $0d5ad8d603a22871$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d5ad8d603a22871$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $0d5ad8d603a22871$var$_react.default.createElement($0d5ad8d603a22871$var$_questionCircle.default, Object.assign({
        name: "QuestionCircleIcon",
        LEGACY_fallbackIcon: $0d5ad8d603a22871$var$_questionCircle2.default
    }, props));
$0d5ad8d603a22871$var$QuestionCircleIcon.displayName = 'QuestionCircleIconMigration';
var $0d5ad8d603a22871$var$_default = module.exports.default = $0d5ad8d603a22871$var$QuestionCircleIcon;

});

parcelRegister("60Odx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::255e9e139447d72d7f96b037f94ce55d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4609b24f82141e62$var$_react = $4609b24f82141e62$var$_interopRequireDefault((parcelRequire("42omo")));

var $4609b24f82141e62$var$_redo = $4609b24f82141e62$var$_interopRequireDefault((parcelRequire("kFjZK")));

var $4609b24f82141e62$var$_redo2 = $4609b24f82141e62$var$_interopRequireDefault((parcelRequire("RZ5dr")));
function $4609b24f82141e62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RedoIcon.
 * This component is RedoIcon, with `UNSAFE_fallbackIcon` set to "RedoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4609b24f82141e62$var$RedoIcon = (props)=>/*#__PURE__*/ $4609b24f82141e62$var$_react.default.createElement($4609b24f82141e62$var$_redo.default, Object.assign({
        name: "RedoIcon",
        LEGACY_fallbackIcon: $4609b24f82141e62$var$_redo2.default
    }, props));
$4609b24f82141e62$var$RedoIcon.displayName = 'RedoIconMigration';
var $4609b24f82141e62$var$_default = module.exports.default = $4609b24f82141e62$var$RedoIcon;

});

parcelRegister("jEno1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3602767f41c26f522cef3955cde6c4d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4e3e4d026e44516$var$_react = $e4e3e4d026e44516$var$_interopRequireDefault((parcelRequire("42omo")));

var $e4e3e4d026e44516$var$_search = $e4e3e4d026e44516$var$_interopRequireDefault((parcelRequire("jluld")));

var $e4e3e4d026e44516$var$_search2 = $e4e3e4d026e44516$var$_interopRequireDefault((parcelRequire("5NBJG")));
function $e4e3e4d026e44516$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "SearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4e3e4d026e44516$var$SearchIcon = (props)=>/*#__PURE__*/ $e4e3e4d026e44516$var$_react.default.createElement($e4e3e4d026e44516$var$_search.default, Object.assign({
        name: "SearchIcon",
        LEGACY_fallbackIcon: $e4e3e4d026e44516$var$_search2.default
    }, props));
$e4e3e4d026e44516$var$SearchIcon.displayName = 'SearchIconMigration';
var $e4e3e4d026e44516$var$_default = module.exports.default = $e4e3e4d026e44516$var$SearchIcon;

});

parcelRegister("jluld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e157839dcf0f91c0$var$_react = $e157839dcf0f91c0$var$_interopRequireDefault((parcelRequire("42omo")));

var $e157839dcf0f91c0$var$_baseNew = $e157839dcf0f91c0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e157839dcf0f91c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e157839dcf0f91c0$var$SearchIcon = (props)=>/*#__PURE__*/ $e157839dcf0f91c0$var$_react.default.createElement($e157839dcf0f91c0$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$e157839dcf0f91c0$var$SearchIcon.displayName = 'SearchIcon';
var $e157839dcf0f91c0$var$_default = module.exports.default = $e157839dcf0f91c0$var$SearchIcon;

});

parcelRegister("h9Ymt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79e640b6af6ce75d2b01f4d5ff86aba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7e21976b3f9a664$var$_react = $c7e21976b3f9a664$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7e21976b3f9a664$var$_undo = $c7e21976b3f9a664$var$_interopRequireDefault((parcelRequire("fnaPh")));

var $c7e21976b3f9a664$var$_undo2 = $c7e21976b3f9a664$var$_interopRequireDefault((parcelRequire("a73CT")));
function $c7e21976b3f9a664$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7e21976b3f9a664$var$UndoIcon = (props)=>/*#__PURE__*/ $c7e21976b3f9a664$var$_react.default.createElement($c7e21976b3f9a664$var$_undo.default, Object.assign({
        name: "UndoIcon",
        LEGACY_fallbackIcon: $c7e21976b3f9a664$var$_undo2.default
    }, props));
$c7e21976b3f9a664$var$UndoIcon.displayName = 'UndoIconMigration';
var $c7e21976b3f9a664$var$_default = module.exports.default = $c7e21976b3f9a664$var$UndoIcon;

});

parcelRegister("fnaPh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd1cfcbb5080c9044de22389be7f741e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b31166db90933ed7$var$_react = $b31166db90933ed7$var$_interopRequireDefault((parcelRequire("42omo")));

var $b31166db90933ed7$var$_baseNew = $b31166db90933ed7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b31166db90933ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b31166db90933ed7$var$UndoIcon = (props)=>/*#__PURE__*/ $b31166db90933ed7$var$_react.default.createElement($b31166db90933ed7$var$_baseNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b31166db90933ed7$var$UndoIcon.displayName = 'UndoIcon';
var $b31166db90933ed7$var$_default = module.exports.default = $b31166db90933ed7$var$UndoIcon;

});

parcelRegister("hge3g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c90ed4ab1b43d107$var$_react = $c90ed4ab1b43d107$var$_interopRequireDefault((parcelRequire("42omo")));

var $c90ed4ab1b43d107$var$_baseNew = $c90ed4ab1b43d107$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c90ed4ab1b43d107$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c90ed4ab1b43d107$var$AiAgentIcon = (props)=>/*#__PURE__*/ $c90ed4ab1b43d107$var$_react.default.createElement($c90ed4ab1b43d107$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$c90ed4ab1b43d107$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $c90ed4ab1b43d107$var$_default = module.exports.default = $c90ed4ab1b43d107$var$AiAgentIcon;

});

parcelRegister("lDwiy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbcf1d1b12cba221f9c450106ed39371>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc064b3d27071ad4$var$_react = $fc064b3d27071ad4$var$_interopRequireDefault((parcelRequire("42omo")));

var $fc064b3d27071ad4$var$_baseNew = $fc064b3d27071ad4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc064b3d27071ad4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc064b3d27071ad4$var$AiChatIcon = (props)=>/*#__PURE__*/ $fc064b3d27071ad4$var$_react.default.createElement($fc064b3d27071ad4$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$fc064b3d27071ad4$var$AiChatIcon.displayName = 'AiChatIcon';
var $fc064b3d27071ad4$var$_default = module.exports.default = $fc064b3d27071ad4$var$AiChatIcon;

});

parcelRegister("a6IPc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07658a43ee3277e5d5c56493565b6ae4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75bd3c30fa6e8c6c$var$_react = $75bd3c30fa6e8c6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $75bd3c30fa6e8c6c$var$_baseNew = $75bd3c30fa6e8c6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $75bd3c30fa6e8c6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75bd3c30fa6e8c6c$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $75bd3c30fa6e8c6c$var$_react.default.createElement($75bd3c30fa6e8c6c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextSummaryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$75bd3c30fa6e8c6c$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $75bd3c30fa6e8c6c$var$_default = module.exports.default = $75bd3c30fa6e8c6c$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("dxgIg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::180a57d95eb8288c183806a1527d613b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $028b0574cc6a9f17$var$_react = $028b0574cc6a9f17$var$_interopRequireDefault((parcelRequire("42omo")));

var $028b0574cc6a9f17$var$_baseNew = $028b0574cc6a9f17$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $028b0574cc6a9f17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $028b0574cc6a9f17$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $028b0574cc6a9f17$var$_react.default.createElement($028b0574cc6a9f17$var$_baseNew.default, Object.assign({
        name: "AlignImageCenterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$028b0574cc6a9f17$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $028b0574cc6a9f17$var$_default = module.exports.default = $028b0574cc6a9f17$var$AlignImageCenterIcon;

});

parcelRegister("6bJyJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cec8b305f101f10fbc944cd0b6e15b18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48171c3d6f76d148$var$_react = $48171c3d6f76d148$var$_interopRequireDefault((parcelRequire("42omo")));

var $48171c3d6f76d148$var$_baseNew = $48171c3d6f76d148$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $48171c3d6f76d148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $48171c3d6f76d148$var$AlignTextLeftIcon = (props)=>/*#__PURE__*/ $48171c3d6f76d148$var$_react.default.createElement($48171c3d6f76d148$var$_baseNew.default, Object.assign({
        name: "AlignTextLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$48171c3d6f76d148$var$AlignTextLeftIcon.displayName = 'AlignTextLeftIcon';
var $48171c3d6f76d148$var$_default = module.exports.default = $48171c3d6f76d148$var$AlignTextLeftIcon;

});

parcelRegister("cOZT3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a15bf40ae6f5b6a0f298d8dba5bbfc13>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955a2906455b334a$var$_react = $955a2906455b334a$var$_interopRequireDefault((parcelRequire("42omo")));

var $955a2906455b334a$var$_baseNew = $955a2906455b334a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $955a2906455b334a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $955a2906455b334a$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $955a2906455b334a$var$_react.default.createElement($955a2906455b334a$var$_baseNew.default, Object.assign({
        name: "AlignTextRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$955a2906455b334a$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $955a2906455b334a$var$_default = module.exports.default = $955a2906455b334a$var$AlignTextRightIcon;

});

parcelRegister("tvI67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9ead16e674236e7db1510f3a48e86deb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $058b4e8b1f67a9a7$var$_react = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("42omo")));

var $058b4e8b1f67a9a7$var$_baseNew = $058b4e8b1f67a9a7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $058b4e8b1f67a9a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $058b4e8b1f67a9a7$var$AppsIcon = (props)=>/*#__PURE__*/ $058b4e8b1f67a9a7$var$_react.default.createElement($058b4e8b1f67a9a7$var$_baseNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$058b4e8b1f67a9a7$var$AppsIcon.displayName = 'AppsIcon';
var $058b4e8b1f67a9a7$var$_default = module.exports.default = $058b4e8b1f67a9a7$var$AppsIcon;

});

parcelRegister("3Mg7y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2cff70d9276c693dca9eb8c1c54a9e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c025c0f3e877a1a$var$_react = $2c025c0f3e877a1a$var$_interopRequireDefault((parcelRequire("42omo")));

var $2c025c0f3e877a1a$var$_baseNew = $2c025c0f3e877a1a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2c025c0f3e877a1a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence apps or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c025c0f3e877a1a$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $2c025c0f3e877a1a$var$_react.default.createElement($2c025c0f3e877a1a$var$_baseNew.default, Object.assign({
        name: "AtlassianIntelligenceIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 12v3h-1.5v-3zm-2.22-1.47-4 4-1.06-1.06 4-4zm8 2.94-1.06 1.06-4-4 1.06-1.06zM4 7.25v1.5H1v-1.5zm11 0v1.5h-3v-1.5zM6.53 5.47 5.47 6.53l-4-4 1.06-1.06zm8-2.94-4 4-1.06-1.06 4-4zM8.75 1v3h-1.5V1z"/>`
    }, props));
$2c025c0f3e877a1a$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $2c025c0f3e877a1a$var$_default = module.exports.default = $2c025c0f3e877a1a$var$AtlassianIntelligenceIcon;

});

parcelRegister("6oGZN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97990c4769833190a022224ac3fdbe68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a865600310e4a08$var$_react = $4a865600310e4a08$var$_interopRequireDefault((parcelRequire("42omo")));

var $4a865600310e4a08$var$_baseNew = $4a865600310e4a08$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4a865600310e4a08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Border".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for toggling the visibility of a border on an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a865600310e4a08$var$BorderIcon = (props)=>/*#__PURE__*/ $4a865600310e4a08$var$_react.default.createElement($4a865600310e4a08$var$_baseNew.default, Object.assign({
        name: "BorderIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5.5 8A.75.75 0 1 1 4 8a.75.75 0 0 1 1.5 0M12 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 12 8m-3.25 3.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0-6.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$4a865600310e4a08$var$BorderIcon.displayName = 'BorderIcon';
var $4a865600310e4a08$var$_default = module.exports.default = $4a865600310e4a08$var$BorderIcon;

});

parcelRegister("iOozU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5d8d971bf9def65ea3fd98a53d2a797b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db1ff63bcd94ca4d$var$_react = $db1ff63bcd94ca4d$var$_interopRequireDefault((parcelRequire("42omo")));

var $db1ff63bcd94ca4d$var$_baseNew = $db1ff63bcd94ca4d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $db1ff63bcd94ca4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db1ff63bcd94ca4d$var$BranchIcon = (props)=>/*#__PURE__*/ $db1ff63bcd94ca4d$var$_react.default.createElement($db1ff63bcd94ca4d$var$_baseNew.default, Object.assign({
        name: "BranchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$db1ff63bcd94ca4d$var$BranchIcon.displayName = 'BranchIcon';
var $db1ff63bcd94ca4d$var$_default = module.exports.default = $db1ff63bcd94ca4d$var$BranchIcon;

});

parcelRegister("oeZjt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fe1fe9833d3664cbcca445cd4b54d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $048dde4b64cb5797$var$_react = $048dde4b64cb5797$var$_interopRequireDefault((parcelRequire("42omo")));

var $048dde4b64cb5797$var$_baseNew = $048dde4b64cb5797$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $048dde4b64cb5797$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $048dde4b64cb5797$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $048dde4b64cb5797$var$_react.default.createElement($048dde4b64cb5797$var$_baseNew.default, Object.assign({
        name: "BriefcaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$048dde4b64cb5797$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $048dde4b64cb5797$var$_default = module.exports.default = $048dde4b64cb5797$var$BriefcaseIcon;

});

parcelRegister("2ISy2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1c065f0aa91b3c3f089345b7ec72ae8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fba00e8bdfff300$var$_react = $1fba00e8bdfff300$var$_interopRequireDefault((parcelRequire("42omo")));

var $1fba00e8bdfff300$var$_baseNew = $1fba00e8bdfff300$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1fba00e8bdfff300$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fba00e8bdfff300$var$BugIcon = (props)=>/*#__PURE__*/ $1fba00e8bdfff300$var$_react.default.createElement($1fba00e8bdfff300$var$_baseNew.default, Object.assign({
        name: "BugIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$1fba00e8bdfff300$var$BugIcon.displayName = 'BugIcon';
var $1fba00e8bdfff300$var$_default = module.exports.default = $1fba00e8bdfff300$var$BugIcon;

});

parcelRegister("ey1uv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a1ef6001ab87a1d8d52e3fa36b1ca44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a97565c2f60dd3c7$var$_react = $a97565c2f60dd3c7$var$_interopRequireDefault((parcelRequire("42omo")));

var $a97565c2f60dd3c7$var$_baseNew = $a97565c2f60dd3c7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a97565c2f60dd3c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a97565c2f60dd3c7$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $a97565c2f60dd3c7$var$_react.default.createElement($a97565c2f60dd3c7$var$_baseNew.default, Object.assign({
        name: "ChevronDoubleLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$a97565c2f60dd3c7$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $a97565c2f60dd3c7$var$_default = module.exports.default = $a97565c2f60dd3c7$var$ChevronDoubleLeftIcon;

});

parcelRegister("iV0NL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2531378e8141a8eb47ef57d9a7bb8c78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc5e2c127e9d0cae$var$_react = $dc5e2c127e9d0cae$var$_interopRequireDefault((parcelRequire("42omo")));

var $dc5e2c127e9d0cae$var$_baseNew = $dc5e2c127e9d0cae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dc5e2c127e9d0cae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clipboard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Pasting content from clipboard.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc5e2c127e9d0cae$var$ClipboardIcon = (props)=>/*#__PURE__*/ $dc5e2c127e9d0cae$var$_react.default.createElement($dc5e2c127e9d0cae$var$_baseNew.default, Object.assign({
        name: "ClipboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.563 1.5A2 2 0 0 1 6.5 0h3a2 2 0 0 1 1.937 1.5H12.5a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2zM4.5 3h-1a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-1v1.25a.75.75 0 0 1-.75.75h-5.5a.75.75 0 0 1-.75-.75zm2-1.5A.5.5 0 0 0 6 2v1.5h4V2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$dc5e2c127e9d0cae$var$ClipboardIcon.displayName = 'ClipboardIcon';
var $dc5e2c127e9d0cae$var$_default = module.exports.default = $dc5e2c127e9d0cae$var$ClipboardIcon;

});

parcelRegister("kevJM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70c18cea03e42e8a3d7697150185e8c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebadbbd41d66ce79$var$_react = $ebadbbd41d66ce79$var$_interopRequireDefault((parcelRequire("42omo")));

var $ebadbbd41d66ce79$var$_baseNew = $ebadbbd41d66ce79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ebadbbd41d66ce79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebadbbd41d66ce79$var$ClockIcon = (props)=>/*#__PURE__*/ $ebadbbd41d66ce79$var$_react.default.createElement($ebadbbd41d66ce79$var$_baseNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$ebadbbd41d66ce79$var$ClockIcon.displayName = 'ClockIcon';
var $ebadbbd41d66ce79$var$_default = module.exports.default = $ebadbbd41d66ce79$var$ClockIcon;

});

parcelRegister("c6fYi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845a551e9d1559487f6fc7548e65832d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cf26f2bc07c2e80$var$_react = $8cf26f2bc07c2e80$var$_interopRequireDefault((parcelRequire("42omo")));

var $8cf26f2bc07c2e80$var$_baseNew = $8cf26f2bc07c2e80$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8cf26f2bc07c2e80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CommentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cf26f2bc07c2e80$var$CommentAddIcon = (props)=>/*#__PURE__*/ $8cf26f2bc07c2e80$var$_react.default.createElement($8cf26f2bc07c2e80$var$_baseNew.default, Object.assign({
        name: "CommentAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM7.25 6.5V4.25h1.5V6.5H11V8H8.75v2.25h-1.5V8H5V6.5z" clip-rule="evenodd"/>`
    }, props));
$8cf26f2bc07c2e80$var$CommentAddIcon.displayName = 'CommentAddIcon';
var $8cf26f2bc07c2e80$var$_default = module.exports.default = $8cf26f2bc07c2e80$var$CommentAddIcon;

});

parcelRegister("fZeLS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ab489d2a38e8a0acc1962f05ff04e40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba3802bfc897cb60$var$_react = $ba3802bfc897cb60$var$_interopRequireDefault((parcelRequire("42omo")));

var $ba3802bfc897cb60$var$_baseNew = $ba3802bfc897cb60$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ba3802bfc897cb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba3802bfc897cb60$var$CommitIcon = (props)=>/*#__PURE__*/ $ba3802bfc897cb60$var$_react.default.createElement($ba3802bfc897cb60$var$_baseNew.default, Object.assign({
        name: "CommitIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$ba3802bfc897cb60$var$CommitIcon.displayName = 'CommitIcon';
var $ba3802bfc897cb60$var$_default = module.exports.default = $ba3802bfc897cb60$var$CommitIcon;

});

parcelRegister("kVA9C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::adfd5c9ab73377c962b9450e729cb10b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3c52cfbfa3758a2$var$_react = $f3c52cfbfa3758a2$var$_interopRequireDefault((parcelRequire("42omo")));

var $f3c52cfbfa3758a2$var$_baseNew = $f3c52cfbfa3758a2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f3c52cfbfa3758a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3c52cfbfa3758a2$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $f3c52cfbfa3758a2$var$_react.default.createElement($f3c52cfbfa3758a2$var$_baseNew.default, Object.assign({
        name: "ContentWrapRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$f3c52cfbfa3758a2$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $f3c52cfbfa3758a2$var$_default = module.exports.default = $f3c52cfbfa3758a2$var$ContentWrapRightIcon;

});

parcelRegister("isYda", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3a6b9bc7cd562874d0d59c11159dd71>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7198c401b27c5bf$var$_react = $d7198c401b27c5bf$var$_interopRequireDefault((parcelRequire("42omo")));

var $d7198c401b27c5bf$var$_baseNew = $d7198c401b27c5bf$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d7198c401b27c5bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d7198c401b27c5bf$var$CustomizeIcon = (props)=>/*#__PURE__*/ $d7198c401b27c5bf$var$_react.default.createElement($d7198c401b27c5bf$var$_baseNew.default, Object.assign({
        name: "CustomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$d7198c401b27c5bf$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $d7198c401b27c5bf$var$_default = module.exports.default = $d7198c401b27c5bf$var$CustomizeIcon;

});

parcelRegister("6B0jU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45d0c4a069ece6c9f88ce3249bf2ac29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cd67254f0b6e2d7$var$_react = $4cd67254f0b6e2d7$var$_interopRequireDefault((parcelRequire("42omo")));

var $4cd67254f0b6e2d7$var$_baseNew = $4cd67254f0b6e2d7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4cd67254f0b6e2d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Database".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for databases in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cd67254f0b6e2d7$var$DatabaseIcon = (props)=>/*#__PURE__*/ $4cd67254f0b6e2d7$var$_react.default.createElement($4cd67254f0b6e2d7$var$_baseNew.default, Object.assign({
        name: "DatabaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.5h11V3a.5.5 0 0 0-.5-.5zM13.5 8H8.75v2h4.75zm0 3.5H8.75v2H13a.5.5 0 0 0 .5-.5zm-6.25 2v-2H2.5V13a.5.5 0 0 0 .5.5zM2.5 10h4.75V8H2.5z" clip-rule="evenodd"/>`
    }, props));
$4cd67254f0b6e2d7$var$DatabaseIcon.displayName = 'DatabaseIcon';
var $4cd67254f0b6e2d7$var$_default = module.exports.default = $4cd67254f0b6e2d7$var$DatabaseIcon;

});

parcelRegister("8aNCk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f35bedb3159b9c4$var$_react = $5f35bedb3159b9c4$var$_interopRequireDefault((parcelRequire("42omo")));

var $5f35bedb3159b9c4$var$_baseNew = $5f35bedb3159b9c4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5f35bedb3159b9c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f35bedb3159b9c4$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $5f35bedb3159b9c4$var$_react.default.createElement($5f35bedb3159b9c4$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$5f35bedb3159b9c4$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $5f35bedb3159b9c4$var$_default = module.exports.default = $5f35bedb3159b9c4$var$DragHandleVerticalIcon;

});

parcelRegister("gXn1S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22bacfedeff92b2f9e10ae98e305ee3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c584052b4d4e6332$var$_react = $c584052b4d4e6332$var$_interopRequireDefault((parcelRequire("42omo")));

var $c584052b4d4e6332$var$_baseNew = $c584052b4d4e6332$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c584052b4d4e6332$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c584052b4d4e6332$var$FilesIcon = (props)=>/*#__PURE__*/ $c584052b4d4e6332$var$_react.default.createElement($c584052b4d4e6332$var$_baseNew.default, Object.assign({
        name: "FilesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$c584052b4d4e6332$var$FilesIcon.displayName = 'FilesIcon';
var $c584052b4d4e6332$var$_default = module.exports.default = $c584052b4d4e6332$var$FilesIcon;

});

parcelRegister("5tmwS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fc12308ace7d017$var$_react = $3fc12308ace7d017$var$_interopRequireDefault((parcelRequire("42omo")));

var $3fc12308ace7d017$var$_baseNew = $3fc12308ace7d017$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3fc12308ace7d017$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3fc12308ace7d017$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $3fc12308ace7d017$var$_react.default.createElement($3fc12308ace7d017$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3fc12308ace7d017$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $3fc12308ace7d017$var$_default = module.exports.default = $3fc12308ace7d017$var$FolderClosedIcon;

});

parcelRegister("buthI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4a75f30383a815136b76433b9d7ec6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85d936684e889e70$var$_react = $85d936684e889e70$var$_interopRequireDefault((parcelRequire("42omo")));

var $85d936684e889e70$var$_baseNew = $85d936684e889e70$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $85d936684e889e70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85d936684e889e70$var$GlobeIcon = (props)=>/*#__PURE__*/ $85d936684e889e70$var$_react.default.createElement($85d936684e889e70$var$_baseNew.default, Object.assign({
        name: "GlobeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$85d936684e889e70$var$GlobeIcon.displayName = 'GlobeIcon';
var $85d936684e889e70$var$_default = module.exports.default = $85d936684e889e70$var$GlobeIcon;

});

parcelRegister("gJsgh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbad77de446eef064b1cc237161c7df0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2e6c576bef3e780$var$_react = $c2e6c576bef3e780$var$_interopRequireDefault((parcelRequire("42omo")));

var $c2e6c576bef3e780$var$_baseNew = $c2e6c576bef3e780$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c2e6c576bef3e780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2e6c576bef3e780$var$GoalIcon = (props)=>/*#__PURE__*/ $c2e6c576bef3e780$var$_react.default.createElement($c2e6c576bef3e780$var$_baseNew.default, Object.assign({
        name: "GoalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$c2e6c576bef3e780$var$GoalIcon.displayName = 'GoalIcon';
var $c2e6c576bef3e780$var$_default = module.exports.default = $c2e6c576bef3e780$var$GoalIcon;

});

parcelRegister("lFPm8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdb939b93a8524d001fd2c490c8f16c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc75438dc597ca4f$var$_react = $fc75438dc597ca4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $fc75438dc597ca4f$var$_baseNew = $fc75438dc597ca4f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc75438dc597ca4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc75438dc597ca4f$var$GrowVerticalIcon = (props)=>/*#__PURE__*/ $fc75438dc597ca4f$var$_react.default.createElement($fc75438dc597ca4f$var$_baseNew.default, Object.assign({
        name: "GrowVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.47 15.78-3.5-3.5 1.06-1.06 2.22 2.22V9h1.5v4.44l2.22-2.22 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0M7.25 2.56 5.03 4.78 3.97 3.72l3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06-2.22-2.22V7h-1.5z" clip-rule="evenodd"/>`
    }, props));
$fc75438dc597ca4f$var$GrowVerticalIcon.displayName = 'GrowVerticalIcon';
var $fc75438dc597ca4f$var$_default = module.exports.default = $fc75438dc597ca4f$var$GrowVerticalIcon;

});

parcelRegister("j8LwF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f70ab5e3a87145f8e8b459a1ba4993>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $def3a15086be2119$var$_react = $def3a15086be2119$var$_interopRequireDefault((parcelRequire("42omo")));

var $def3a15086be2119$var$_baseNew = $def3a15086be2119$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $def3a15086be2119$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $def3a15086be2119$var$HeartIcon = (props)=>/*#__PURE__*/ $def3a15086be2119$var$_react.default.createElement($def3a15086be2119$var$_baseNew.default, Object.assign({
        name: "HeartIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.036 2.75a2.86 2.86 0 0 0-2.144.913 3.3 3.3 0 0 0-.656 1.064A3.9 3.9 0 0 0 2 6.112c0 .83.216 1.666.672 2.518.468.862 1.14 1.722 2.033 2.577q1.344 1.283 3.206 2.475a1 1 0 0 0 .09.047 1 1 0 0 0 .095-.047q1.862-1.193 3.199-2.474c.893-.856 1.563-1.716 2.026-2.578.46-.852.679-1.688.679-2.517 0-.522-.084-.98-.241-1.382l-.003-.007a3.2 3.2 0 0 0-.648-1.06l-.003-.003a2.8 2.8 0 0 0-.95-.672l-.002-.001a2.9 2.9 0 0 0-1.19-.237c-.525 0-.958.133-1.326.382l-.004.002a3 3 0 0 0-.975 1.085l-.66 1.205-.657-1.207a3 3 0 0 0-.971-1.085c-.367-.249-.802-.382-1.334-.382M3.248 1.612a4.4 4.4 0 0 1 1.788-.362c.801 0 1.535.207 2.174.64q.439.296.791.682.356-.388.797-.684c.638-.43 1.37-.638 2.166-.638.63 0 1.229.118 1.787.362q.836.361 1.454 1.028c.414.442.73.962.953 1.549a5.3 5.3 0 0 1 .342 1.923c0 1.105-.294 2.184-.858 3.23-.552 1.025-1.327 2.007-2.31 2.949Q10.87 13.69 8.9 14.948l-.006.004a2 2 0 0 1-.362.18A1.3 1.3 0 0 1 8 15.25c-.205 0-.389-.058-.532-.118a2.3 2.3 0 0 1-.355-.18l-.006-.004q-1.97-1.258-3.438-2.656l-.001-.001c-.983-.941-1.76-1.923-2.316-2.948l-.002-.004C.79 8.294.5 7.216.5 6.112c0-.683.108-1.326.335-1.921l.001-.004a4.8 4.8 0 0 1 .961-1.55 4.4 4.4 0 0 1 1.45-1.025" clip-rule="evenodd"/>`
    }, props));
$def3a15086be2119$var$HeartIcon.displayName = 'HeartIcon';
var $def3a15086be2119$var$_default = module.exports.default = $def3a15086be2119$var$HeartIcon;

});

parcelRegister("eJ7sW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c75712994f6f10547115c96cb84c098>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8b0f3080f751ce$var$_react = $ab8b0f3080f751ce$var$_interopRequireDefault((parcelRequire("42omo")));

var $ab8b0f3080f751ce$var$_baseNew = $ab8b0f3080f751ce$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ab8b0f3080f751ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageFullscreen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for viewing an image in a fullscreen view or modal.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8b0f3080f751ce$var$ImageFullscreenIcon = (props)=>/*#__PURE__*/ $ab8b0f3080f751ce$var$_react.default.createElement($ab8b0f3080f751ce$var$_baseNew.default, Object.assign({
        name: "ImageFullscreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 1.5H5V0H1.375C.615 0 0 .616 0 1.375V5h1.5zM3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h.633l2.892-3.719a1.375 1.375 0 0 1 1.927-.244l1.048.81V5a.5.5 0 0 0-.5-.5zm6.5 5.743L9.633 8.801l-2.1 2.699H11a.5.5 0 0 0 .5-.5zM16 11v3.625c0 .76-.616 1.375-1.375 1.375H11v-1.5h3.5V11z" clip-rule="evenodd"/><path fill="currentcolor" d="M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$ab8b0f3080f751ce$var$ImageFullscreenIcon.displayName = 'ImageFullscreenIcon';
var $ab8b0f3080f751ce$var$_default = module.exports.default = $ab8b0f3080f751ce$var$ImageFullscreenIcon;

});

parcelRegister("5LN4K", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f39860ce7f984391648fef01b18ffad3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $433768e8b236c22b$var$_react = $433768e8b236c22b$var$_interopRequireDefault((parcelRequire("42omo")));

var $433768e8b236c22b$var$_baseNew = $433768e8b236c22b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $433768e8b236c22b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $433768e8b236c22b$var$IncidentIcon = (props)=>/*#__PURE__*/ $433768e8b236c22b$var$_react.default.createElement($433768e8b236c22b$var$_baseNew.default, Object.assign({
        name: "IncidentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$433768e8b236c22b$var$IncidentIcon.displayName = 'IncidentIcon';
var $433768e8b236c22b$var$_default = module.exports.default = $433768e8b236c22b$var$IncidentIcon;

});

parcelRegister("8tSmd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2379769942b452821345d3db8e1641c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62cb326b30b506fa$var$_react = $62cb326b30b506fa$var$_interopRequireDefault((parcelRequire("42omo")));

var $62cb326b30b506fa$var$_baseNew = $62cb326b30b506fa$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $62cb326b30b506fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62cb326b30b506fa$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $62cb326b30b506fa$var$_react.default.createElement($62cb326b30b506fa$var$_baseNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$62cb326b30b506fa$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $62cb326b30b506fa$var$_default = module.exports.default = $62cb326b30b506fa$var$InformationCircleIcon;

});

parcelRegister("bmsMK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d59b5ed561b25f3fb1da55a522fb8984>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $845813ef66c5dec4$var$_react = $845813ef66c5dec4$var$_interopRequireDefault((parcelRequire("42omo")));

var $845813ef66c5dec4$var$_baseNew = $845813ef66c5dec4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $845813ef66c5dec4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutOneColumn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for single column layout option in Confluence Editor
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $845813ef66c5dec4$var$LayoutOneColumnIcon = (props)=>/*#__PURE__*/ $845813ef66c5dec4$var$_react.default.createElement($845813ef66c5dec4$var$_baseNew.default, Object.assign({
        name: "LayoutOneColumnIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h13.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 15 0 14.384 0 13.625zm1.5.125v11h13v-11z" clip-rule="evenodd"/>`
    }, props));
$845813ef66c5dec4$var$LayoutOneColumnIcon.displayName = 'LayoutOneColumnIcon';
var $845813ef66c5dec4$var$_default = module.exports.default = $845813ef66c5dec4$var$LayoutOneColumnIcon;

});

parcelRegister("asgOl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::41241beb7c997812002aebca60cfbf2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79c98f36543962c5$var$_react = $79c98f36543962c5$var$_interopRequireDefault((parcelRequire("42omo")));

var $79c98f36543962c5$var$_baseNew = $79c98f36543962c5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $79c98f36543962c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79c98f36543962c5$var$LayoutTwoColumnsIcon = (props)=>/*#__PURE__*/ $79c98f36543962c5$var$_react.default.createElement($79c98f36543962c5$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h4.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5C.615 15 0 14.384 0 13.625zm1.5.125v11h4.25v-11zm7.25-.125c0-.76.616-1.375 1.375-1.375h4.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-4.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h4.25v-11z" clip-rule="evenodd"/>`
    }, props));
$79c98f36543962c5$var$LayoutTwoColumnsIcon.displayName = 'LayoutTwoColumnsIcon';
var $79c98f36543962c5$var$_default = module.exports.default = $79c98f36543962c5$var$LayoutTwoColumnsIcon;

});

parcelRegister("e0qVa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4628d836a2702117fd4aa5f1325a9af2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a325f2c006296fa4$var$_react = $a325f2c006296fa4$var$_interopRequireDefault((parcelRequire("42omo")));

var $a325f2c006296fa4$var$_baseNew = $a325f2c006296fa4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a325f2c006296fa4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a325f2c006296fa4$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $a325f2c006296fa4$var$_react.default.createElement($a325f2c006296fa4$var$_baseNew.default, Object.assign({
        name: "LayoutTwoColumnsSidebarLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$a325f2c006296fa4$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $a325f2c006296fa4$var$_default = module.exports.default = $a325f2c006296fa4$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("dZMVn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae3bff1d1955acd002e5417a314968c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a306ec40c1ecbd43$var$_react = $a306ec40c1ecbd43$var$_interopRequireDefault((parcelRequire("42omo")));

var $a306ec40c1ecbd43$var$_baseNew = $a306ec40c1ecbd43$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a306ec40c1ecbd43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a306ec40c1ecbd43$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $a306ec40c1ecbd43$var$_react.default.createElement($a306ec40c1ecbd43$var$_baseNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$a306ec40c1ecbd43$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $a306ec40c1ecbd43$var$_default = module.exports.default = $a306ec40c1ecbd43$var$LinkBrokenIcon;

});

parcelRegister("cUQMr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9673a80bb01a05da$var$_react = $9673a80bb01a05da$var$_interopRequireDefault((parcelRequire("42omo")));

var $9673a80bb01a05da$var$_baseNew = $9673a80bb01a05da$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9673a80bb01a05da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9673a80bb01a05da$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $9673a80bb01a05da$var$_react.default.createElement($9673a80bb01a05da$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$9673a80bb01a05da$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $9673a80bb01a05da$var$_default = module.exports.default = $9673a80bb01a05da$var$ListBulletedIcon;

});

parcelRegister("54tpX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed25eca7ff6536d97038e7bf1d155990>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b142538ea0dcd4b$var$_react = $3b142538ea0dcd4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $3b142538ea0dcd4b$var$_baseNew = $3b142538ea0dcd4b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3b142538ea0dcd4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b142538ea0dcd4b$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $3b142538ea0dcd4b$var$_react.default.createElement($3b142538ea0dcd4b$var$_baseNew.default, Object.assign({
        name: "ListChecklistIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$3b142538ea0dcd4b$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $3b142538ea0dcd4b$var$_default = module.exports.default = $3b142538ea0dcd4b$var$ListChecklistIcon;

});

parcelRegister("lW0cT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8d104d01680a4874e0476b0a23060c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff7f2cd6f6a4bab7$var$_react = $ff7f2cd6f6a4bab7$var$_interopRequireDefault((parcelRequire("42omo")));

var $ff7f2cd6f6a4bab7$var$_baseNew = $ff7f2cd6f6a4bab7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $ff7f2cd6f6a4bab7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff7f2cd6f6a4bab7$var$MagicWandIcon = (props)=>/*#__PURE__*/ $ff7f2cd6f6a4bab7$var$_react.default.createElement($ff7f2cd6f6a4bab7$var$_baseNew.default, Object.assign({
        name: "MagicWandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$ff7f2cd6f6a4bab7$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $ff7f2cd6f6a4bab7$var$_default = module.exports.default = $ff7f2cd6f6a4bab7$var$MagicWandIcon;

});

parcelRegister("jNL69", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ff13ff1b2f6b349dbd101944acc1762>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6a720a4c8635701$var$_react = $e6a720a4c8635701$var$_interopRequireDefault((parcelRequire("42omo")));

var $e6a720a4c8635701$var$_baseNew = $e6a720a4c8635701$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e6a720a4c8635701$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Maximize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for resizing screens, panels, modals, or media to its maximum size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6a720a4c8635701$var$MaximizeIcon = (props)=>/*#__PURE__*/ $e6a720a4c8635701$var$_react.default.createElement($e6a720a4c8635701$var$_baseNew.default, Object.assign({
        name: "MaximizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zm-2-.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM8 4H4.75a.75.75 0 0 0-.75.75V8h1.5V5.5H8zm2.5 6.5V8H12v3.25a.75.75 0 0 1-.75.75H8v-1.5z" clip-rule="evenodd"/>`
    }, props));
$e6a720a4c8635701$var$MaximizeIcon.displayName = 'MaximizeIcon';
var $e6a720a4c8635701$var$_default = module.exports.default = $e6a720a4c8635701$var$MaximizeIcon;

});

parcelRegister("bQ6eU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa3ac1cb079d613c521a1d89096297a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e9640dc04fdc75$var$_react = $89e9640dc04fdc75$var$_interopRequireDefault((parcelRequire("42omo")));

var $89e9640dc04fdc75$var$_baseNew = $89e9640dc04fdc75$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $89e9640dc04fdc75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89e9640dc04fdc75$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $89e9640dc04fdc75$var$_react.default.createElement($89e9640dc04fdc75$var$_baseNew.default, Object.assign({
        name: "MergeFailureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$89e9640dc04fdc75$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $89e9640dc04fdc75$var$_default = module.exports.default = $89e9640dc04fdc75$var$MergeFailureIcon;

});

parcelRegister("jypE9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24c85da433a7def76f682c2e482c8374>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3c5162d320d5390$var$_react = $e3c5162d320d5390$var$_interopRequireDefault((parcelRequire("42omo")));

var $e3c5162d320d5390$var$_baseNew = $e3c5162d320d5390$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e3c5162d320d5390$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3c5162d320d5390$var$PanelRightIcon = (props)=>/*#__PURE__*/ $e3c5162d320d5390$var$_react.default.createElement($e3c5162d320d5390$var$_baseNew.default, Object.assign({
        name: "PanelRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$e3c5162d320d5390$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $e3c5162d320d5390$var$_default = module.exports.default = $e3c5162d320d5390$var$PanelRightIcon;

});

parcelRegister("brxEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc94c033304ea9f771c822850910b341>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $854c52b418175d2e$var$_react = $854c52b418175d2e$var$_interopRequireDefault((parcelRequire("42omo")));

var $854c52b418175d2e$var$_baseNew = $854c52b418175d2e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $854c52b418175d2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PinFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: pinned fields.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $854c52b418175d2e$var$PinFilledIcon = (props)=>/*#__PURE__*/ $854c52b418175d2e$var$_react.default.createElement($854c52b418175d2e$var$_baseNew.default, Object.assign({
        name: "PinFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.354 0a1.376 1.376 0 0 0-1.268 1.908l.089.174L5 3.458v3.475a5 5 0 0 0-1.184.61C2.898 8.195 2 9.348 2 11.25c0 .414.336.75.75.75h4.5v4h1.5v-4h4.5a.75.75 0 0 0 .75-.75c0-1.903-.898-3.056-1.816-3.706A5 5 0 0 0 11 6.933V3.458l.825-1.376A1.375 1.375 0 0 0 10.647 0zm4.252 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/><path fill="currentcolor" d="m9.606 2.864-.045.09a.8.8 0 0 0-.061.296V7.5c0 .367.265.68.627.74l.008.001.066.016a3.4 3.4 0 0 1 1.115.512c.463.327.938.852 1.113 1.731H3.57c.175-.88.65-1.404 1.113-1.731a3.4 3.4 0 0 1 1.181-.528l.008-.002A.75.75 0 0 0 6.5 7.5V3.25a.75.75 0 0 0-.106-.386L5.574 1.5h4.852z"/>`
    }, props));
$854c52b418175d2e$var$PinFilledIcon.displayName = 'PinFilledIcon';
var $854c52b418175d2e$var$_default = module.exports.default = $854c52b418175d2e$var$PinFilledIcon;

});

parcelRegister("cHaKZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f7537afae1521ac249370a3c6f08a12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93e1d84ddeabaf54$var$_react = $93e1d84ddeabaf54$var$_interopRequireDefault((parcelRequire("42omo")));

var $93e1d84ddeabaf54$var$_baseNew = $93e1d84ddeabaf54$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $93e1d84ddeabaf54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlusSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'New feature' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93e1d84ddeabaf54$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $93e1d84ddeabaf54$var$_react.default.createElement($93e1d84ddeabaf54$var$_baseNew.default, Object.assign({
        name: "PlusSquareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM8.75 4v3.25H12v1.5H8.75V12h-1.5V8.75H4v-1.5h3.25V4zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$93e1d84ddeabaf54$var$PlusSquareIcon.displayName = 'PlusSquareIcon';
var $93e1d84ddeabaf54$var$_default = module.exports.default = $93e1d84ddeabaf54$var$PlusSquareIcon;

});

parcelRegister("jz9js", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c3166f2fe0f47ea82d95571c4b7ab84>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3e88288e5c7477c$var$_react = $e3e88288e5c7477c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e3e88288e5c7477c$var$_baseNew = $e3e88288e5c7477c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e3e88288e5c7477c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3e88288e5c7477c$var$ProblemIcon = (props)=>/*#__PURE__*/ $e3e88288e5c7477c$var$_react.default.createElement($e3e88288e5c7477c$var$_baseNew.default, Object.assign({
        name: "ProblemIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$e3e88288e5c7477c$var$ProblemIcon.displayName = 'ProblemIcon';
var $e3e88288e5c7477c$var$_default = module.exports.default = $e3e88288e5c7477c$var$ProblemIcon;

});

parcelRegister("bVHZY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e67e12578ad7244dcda8a2916675ce6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8af725c21ff09654$var$_react = $8af725c21ff09654$var$_interopRequireDefault((parcelRequire("42omo")));

var $8af725c21ff09654$var$_baseNew = $8af725c21ff09654$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8af725c21ff09654$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8af725c21ff09654$var$ProjectIcon = (props)=>/*#__PURE__*/ $8af725c21ff09654$var$_react.default.createElement($8af725c21ff09654$var$_baseNew.default, Object.assign({
        name: "ProjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$8af725c21ff09654$var$ProjectIcon.displayName = 'ProjectIcon';
var $8af725c21ff09654$var$_default = module.exports.default = $8af725c21ff09654$var$ProjectIcon;

});

parcelRegister("cOQz3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9af4adec7e453263370a787e5a93d059>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9552edc0b28eb6b8$var$_react = $9552edc0b28eb6b8$var$_interopRequireDefault((parcelRequire("42omo")));

var $9552edc0b28eb6b8$var$_baseNew = $9552edc0b28eb6b8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9552edc0b28eb6b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9552edc0b28eb6b8$var$RovoChatIcon = (props)=>/*#__PURE__*/ $9552edc0b28eb6b8$var$_react.default.createElement($9552edc0b28eb6b8$var$_baseNew.default, Object.assign({
        name: "RovoChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
    }, props));
$9552edc0b28eb6b8$var$RovoChatIcon.displayName = 'RovoChatIcon';
var $9552edc0b28eb6b8$var$_default = module.exports.default = $9552edc0b28eb6b8$var$RovoChatIcon;

});

parcelRegister("jPqj0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b92d5eaec4aa39e36df798a65b362b50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6f72f786af4877e$var$_react = $e6f72f786af4877e$var$_interopRequireDefault((parcelRequire("42omo")));

var $e6f72f786af4877e$var$_baseNew = $e6f72f786af4877e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e6f72f786af4877e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the height of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6f72f786af4877e$var$ShrinkVerticalIcon = (props)=>/*#__PURE__*/ $e6f72f786af4877e$var$_react.default.createElement($e6f72f786af4877e$var$_baseNew.default, Object.assign({
        name: "ShrinkVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 9.75V16h-1.5V9.75zm-1.5-3.5V0h1.5v6.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m8 10.81-2.97 2.97-1.06-1.06 3.5-3.5a.75.75 0 0 1 1.06 0l3.5 3.5-1.06 1.06zm-.53-4.03-3.5-3.5 1.06-1.06L8 5.19l2.97-2.97 1.06 1.06-3.5 3.5a.75.75 0 0 1-1.06 0" clip-rule="evenodd"/>`
    }, props));
$e6f72f786af4877e$var$ShrinkVerticalIcon.displayName = 'ShrinkVerticalIcon';
var $e6f72f786af4877e$var$_default = module.exports.default = $e6f72f786af4877e$var$ShrinkVerticalIcon;

});

parcelRegister("65WMN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f195fae124a1a666932db45e8323e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4700cf64dc1b4499$var$_react = $4700cf64dc1b4499$var$_interopRequireDefault((parcelRequire("42omo")));

var $4700cf64dc1b4499$var$_baseNew = $4700cf64dc1b4499$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4700cf64dc1b4499$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4700cf64dc1b4499$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $4700cf64dc1b4499$var$_react.default.createElement($4700cf64dc1b4499$var$_baseNew.default, Object.assign({
        name: "SmartLinkCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$4700cf64dc1b4499$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $4700cf64dc1b4499$var$_default = module.exports.default = $4700cf64dc1b4499$var$SmartLinkCardIcon;

});

parcelRegister("erzkB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c365d193bb347a901df804122b7b7af0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a83efe5f4eb4a123$var$_react = $a83efe5f4eb4a123$var$_interopRequireDefault((parcelRequire("42omo")));

var $a83efe5f4eb4a123$var$_baseNew = $a83efe5f4eb4a123$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a83efe5f4eb4a123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a83efe5f4eb4a123$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $a83efe5f4eb4a123$var$_react.default.createElement($a83efe5f4eb4a123$var$_baseNew.default, Object.assign({
        name: "SmartLinkInlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$a83efe5f4eb4a123$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $a83efe5f4eb4a123$var$_default = module.exports.default = $a83efe5f4eb4a123$var$SmartLinkInlineIcon;

});

parcelRegister("2g1PW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07d828fd61b2a1fed0f88efa4b3b1005>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a4e801f7b6ed6a8$var$_react = $1a4e801f7b6ed6a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $1a4e801f7b6ed6a8$var$_baseNew = $1a4e801f7b6ed6a8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1a4e801f7b6ed6a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a4e801f7b6ed6a8$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $1a4e801f7b6ed6a8$var$_react.default.createElement($1a4e801f7b6ed6a8$var$_baseNew.default, Object.assign({
        name: "SmartLinkListIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$1a4e801f7b6ed6a8$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $1a4e801f7b6ed6a8$var$_default = module.exports.default = $1a4e801f7b6ed6a8$var$SmartLinkListIcon;

});

parcelRegister("dmsGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa40f37165b56c780c43a081b97fc51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ba39610adeb713a$var$_react = $9ba39610adeb713a$var$_interopRequireDefault((parcelRequire("42omo")));

var $9ba39610adeb713a$var$_baseNew = $9ba39610adeb713a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9ba39610adeb713a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ba39610adeb713a$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $9ba39610adeb713a$var$_react.default.createElement($9ba39610adeb713a$var$_baseNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$9ba39610adeb713a$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $9ba39610adeb713a$var$_default = module.exports.default = $9ba39610adeb713a$var$SortDescendingIcon;

});

parcelRegister("3gddQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd1f6b3811c2db$var$_react = $25fd1f6b3811c2db$var$_interopRequireDefault((parcelRequire("42omo")));

var $25fd1f6b3811c2db$var$_baseNew = $25fd1f6b3811c2db$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $25fd1f6b3811c2db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd1f6b3811c2db$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $25fd1f6b3811c2db$var$_react.default.createElement($25fd1f6b3811c2db$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$25fd1f6b3811c2db$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $25fd1f6b3811c2db$var$_default = module.exports.default = $25fd1f6b3811c2db$var$StatusDiscoveryIcon;

});

parcelRegister("3jDos", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f218031e192f56c45b2f2c356b3c928a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26a1b42dca1644d5$var$_react = $26a1b42dca1644d5$var$_interopRequireDefault((parcelRequire("42omo")));

var $26a1b42dca1644d5$var$_baseNew = $26a1b42dca1644d5$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $26a1b42dca1644d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightLarge".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing thick border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26a1b42dca1644d5$var$StrokeWeightLargeIcon = (props)=>/*#__PURE__*/ $26a1b42dca1644d5$var$_react.default.createElement($26a1b42dca1644d5$var$_baseNew.default, Object.assign({
        name: "StrokeWeightLargeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0" clip-rule="evenodd"/>`
    }, props));
$26a1b42dca1644d5$var$StrokeWeightLargeIcon.displayName = 'StrokeWeightLargeIcon';
var $26a1b42dca1644d5$var$_default = module.exports.default = $26a1b42dca1644d5$var$StrokeWeightLargeIcon;

});

parcelRegister("gfsOF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fdbbd9f959950d1923cb6a1760abe2a2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd44665dcacf96f4$var$_react = $bd44665dcacf96f4$var$_interopRequireDefault((parcelRequire("42omo")));

var $bd44665dcacf96f4$var$_baseNew = $bd44665dcacf96f4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bd44665dcacf96f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightMedium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing medium border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd44665dcacf96f4$var$StrokeWeightMediumIcon = (props)=>/*#__PURE__*/ $bd44665dcacf96f4$var$_react.default.createElement($bd44665dcacf96f4$var$_baseNew.default, Object.assign({
        name: "StrokeWeightMediumIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0" clip-rule="evenodd"/>`
    }, props));
$bd44665dcacf96f4$var$StrokeWeightMediumIcon.displayName = 'StrokeWeightMediumIcon';
var $bd44665dcacf96f4$var$_default = module.exports.default = $bd44665dcacf96f4$var$StrokeWeightMediumIcon;

});

parcelRegister("gDgeb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62e62e57d1c724276255918e43817f68>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1bce0565205fd6b$var$_react = $c1bce0565205fd6b$var$_interopRequireDefault((parcelRequire("42omo")));

var $c1bce0565205fd6b$var$_baseNew = $c1bce0565205fd6b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c1bce0565205fd6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing thin border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1bce0565205fd6b$var$StrokeWeightSmallIcon = (props)=>/*#__PURE__*/ $c1bce0565205fd6b$var$_react.default.createElement($c1bce0565205fd6b$var$_baseNew.default, Object.assign({
        name: "StrokeWeightSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" clip-rule="evenodd"/>`
    }, props));
$c1bce0565205fd6b$var$StrokeWeightSmallIcon.displayName = 'StrokeWeightSmallIcon';
var $c1bce0565205fd6b$var$_default = module.exports.default = $c1bce0565205fd6b$var$StrokeWeightSmallIcon;

});

parcelRegister("49GPt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c160a9f26591f77220765c2e9d99939c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $306939b2308ba4a2$var$_react = $306939b2308ba4a2$var$_interopRequireDefault((parcelRequire("42omo")));

var $306939b2308ba4a2$var$_baseNew = $306939b2308ba4a2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $306939b2308ba4a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $306939b2308ba4a2$var$SubtasksIcon = (props)=>/*#__PURE__*/ $306939b2308ba4a2$var$_react.default.createElement($306939b2308ba4a2$var$_baseNew.default, Object.assign({
        name: "SubtasksIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$306939b2308ba4a2$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $306939b2308ba4a2$var$_default = module.exports.default = $306939b2308ba4a2$var$SubtasksIcon;

});

parcelRegister("iV7dk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf26d580385ecfdfcd87f2bd58ec1e28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc63256df427d22b$var$_react = $dc63256df427d22b$var$_interopRequireDefault((parcelRequire("42omo")));

var $dc63256df427d22b$var$_baseNew = $dc63256df427d22b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $dc63256df427d22b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellClear".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for clearing the contents of table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc63256df427d22b$var$TableCellClearIcon = (props)=>/*#__PURE__*/ $dc63256df427d22b$var$_react.default.createElement($dc63256df427d22b$var$_baseNew.default, Object.assign({
        name: "TableCellClearIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.94 4L5.22 6.28l1.06-1.06L8 6.94l1.72-1.72 1.06 1.06L9.06 8l1.72 1.72-1.06 1.06L8 9.06l-1.72 1.72-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$dc63256df427d22b$var$TableCellClearIcon.displayName = 'TableCellClearIcon';
var $dc63256df427d22b$var$_default = module.exports.default = $dc63256df427d22b$var$TableCellClearIcon;

});

parcelRegister("lZgFC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a318d560503e1d75f56ae6c02c16beaa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04217ccdddd9708b$var$_react = $04217ccdddd9708b$var$_interopRequireDefault((parcelRequire("42omo")));

var $04217ccdddd9708b$var$_baseNew = $04217ccdddd9708b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $04217ccdddd9708b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableCellMerge".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for merging table cells.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04217ccdddd9708b$var$TableCellMergeIcon = (props)=>/*#__PURE__*/ $04217ccdddd9708b$var$_react.default.createElement($04217ccdddd9708b$var$_baseNew.default, Object.assign({
        name: "TableCellMergeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5v1.5zm12 0H9V2h5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9v-1.5h5a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M5.19 8 3.47 6.28l1.06-1.06 2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25-1.06-1.06zm4.03-.53 2.25-2.25 1.06 1.06L10.81 8l1.72 1.72-1.06 1.06-2.25-2.25a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$04217ccdddd9708b$var$TableCellMergeIcon.displayName = 'TableCellMergeIcon';
var $04217ccdddd9708b$var$_default = module.exports.default = $04217ccdddd9708b$var$TableCellMergeIcon;

});

parcelRegister("luItc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b6d4b31b61165ef4461dd86157d3656>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa5ee51f13b2929a$var$_react = $fa5ee51f13b2929a$var$_interopRequireDefault((parcelRequire("42omo")));

var $fa5ee51f13b2929a$var$_baseNew = $fa5ee51f13b2929a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fa5ee51f13b2929a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table column to the left of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa5ee51f13b2929a$var$TableColumnAddLeftIcon = (props)=>/*#__PURE__*/ $fa5ee51f13b2929a$var$_react.default.createElement($fa5ee51f13b2929a$var$_baseNew.default, Object.assign({
        name: "TableColumnAddLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-5.75C8.115 1 7.5 1.616 7.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h5.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11h-2v-11zm-3.5 0v11H9v-11zM3.75 8.75V11h-1.5V8.75H0v-1.5h2.25V5h1.5v2.25H6v1.5z" clip-rule="evenodd"/>`
    }, props));
$fa5ee51f13b2929a$var$TableColumnAddLeftIcon.displayName = 'TableColumnAddLeftIcon';
var $fa5ee51f13b2929a$var$_default = module.exports.default = $fa5ee51f13b2929a$var$TableColumnAddLeftIcon;

});

parcelRegister("6p8nb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2273610a9b93a349641f0c213444e3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a9b9296c5db2796$var$_react = $4a9b9296c5db2796$var$_interopRequireDefault((parcelRequire("42omo")));

var $4a9b9296c5db2796$var$_baseNew = $4a9b9296c5db2796$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4a9b9296c5db2796$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnAddRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table column to the right of the selected column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a9b9296c5db2796$var$TableColumnAddRightIcon = (props)=>/*#__PURE__*/ $4a9b9296c5db2796$var$_react.default.createElement($4a9b9296c5db2796$var$_baseNew.default, Object.assign({
        name: "TableColumnAddRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.25 6.25V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5z" clip-rule="evenodd"/>`
    }, props));
$4a9b9296c5db2796$var$TableColumnAddRightIcon.displayName = 'TableColumnAddRightIcon';
var $4a9b9296c5db2796$var$_default = module.exports.default = $4a9b9296c5db2796$var$TableColumnAddRightIcon;

});

parcelRegister("4Ilrk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16038385fc6c0e921c4511b9a873facf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36ebe6fb6825f20f$var$_react = $36ebe6fb6825f20f$var$_interopRequireDefault((parcelRequire("42omo")));

var $36ebe6fb6825f20f$var$_baseNew = $36ebe6fb6825f20f$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $36ebe6fb6825f20f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnDelete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for deleting a table column.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36ebe6fb6825f20f$var$TableColumnDeleteIcon = (props)=>/*#__PURE__*/ $36ebe6fb6825f20f$var$_react.default.createElement($36ebe6fb6825f20f$var$_baseNew.default, Object.assign({
        name: "TableColumnDeleteIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm11 6.25h-6v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$36ebe6fb6825f20f$var$TableColumnDeleteIcon.displayName = 'TableColumnDeleteIcon';
var $36ebe6fb6825f20f$var$_default = module.exports.default = $36ebe6fb6825f20f$var$TableColumnDeleteIcon;

});

parcelRegister("batr4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6e18278769f6620343a00561f396882>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8217762b794eb7f6$var$_react = $8217762b794eb7f6$var$_interopRequireDefault((parcelRequire("42omo")));

var $8217762b794eb7f6$var$_baseNew = $8217762b794eb7f6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8217762b794eb7f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableColumnMoveRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for moving a table column to the right of its current location.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8217762b794eb7f6$var$TableColumnMoveRightIcon = (props)=>/*#__PURE__*/ $8217762b794eb7f6$var$_react.default.createElement($8217762b794eb7f6$var$_baseNew.default, Object.assign({
        name: "TableColumnMoveRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h5.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-5.75C.615 15 0 14.384 0 13.625zm1.5.125v11h2v-11zm3.5 0v11h2v-11zm7.78 1.97 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 1.72-1.72H10v-1.5h3.44l-1.72-1.72z" clip-rule="evenodd"/>`
    }, props));
$8217762b794eb7f6$var$TableColumnMoveRightIcon.displayName = 'TableColumnMoveRightIcon';
var $8217762b794eb7f6$var$_default = module.exports.default = $8217762b794eb7f6$var$TableColumnMoveRightIcon;

});

parcelRegister("kDG2N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c67cb401590e8dc6b8359dcd6ae741e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f06810448d235834$var$_react = $f06810448d235834$var$_interopRequireDefault((parcelRequire("42omo")));

var $f06810448d235834$var$_baseNew = $f06810448d235834$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f06810448d235834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableRowAddAbove".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for adding a table row above the selected row.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f06810448d235834$var$TableRowAddAboveIcon = (props)=>/*#__PURE__*/ $f06810448d235834$var$_react.default.createElement($f06810448d235834$var$_baseNew.default, Object.assign({
        name: "TableRowAddAboveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.375 16C1.615 16 1 15.384 1 14.625v-5.75c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v5.75c0 .76-.616 1.375-1.375 1.375zm.125-1.5h11v-2h-11zm0-3.5h11V9h-11zm6.25-7.25H11v-1.5H8.75V0h-1.5v2.25H5v1.5h2.25V6h1.5z" clip-rule="evenodd"/>`
    }, props));
$f06810448d235834$var$TableRowAddAboveIcon.displayName = 'TableRowAddAboveIcon';
var $f06810448d235834$var$_default = module.exports.default = $f06810448d235834$var$TableRowAddAboveIcon;

});

parcelRegister("av0Vd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd85a061670900bca44ad5d1568ae5ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a4d83b08d63f467$var$_react = $7a4d83b08d63f467$var$_interopRequireDefault((parcelRequire("42omo")));

var $7a4d83b08d63f467$var$_baseNew = $7a4d83b08d63f467$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7a4d83b08d63f467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a4d83b08d63f467$var$TagIcon = (props)=>/*#__PURE__*/ $7a4d83b08d63f467$var$_react.default.createElement($7a4d83b08d63f467$var$_baseNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$7a4d83b08d63f467$var$TagIcon.displayName = 'TagIcon';
var $7a4d83b08d63f467$var$_default = module.exports.default = $7a4d83b08d63f467$var$TagIcon;

});

parcelRegister("2gUVF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::185c83995a7208ef1c24aad54fb1e0a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a793c546f0fdfeb$var$_react = $1a793c546f0fdfeb$var$_interopRequireDefault((parcelRequire("42omo")));

var $1a793c546f0fdfeb$var$_baseNew = $1a793c546f0fdfeb$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1a793c546f0fdfeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextItalic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for italicizing text.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a793c546f0fdfeb$var$TextItalicIcon = (props)=>/*#__PURE__*/ $1a793c546f0fdfeb$var$_react.default.createElement($1a793c546f0fdfeb$var$_baseNew.default, Object.assign({
        name: "TextItalicIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h6.5v1.5h-2.409l-2.64 11H10V15H3.5v-1.5h2.409l2.64-11H6z" clip-rule="evenodd"/>`
    }, props));
$1a793c546f0fdfeb$var$TextItalicIcon.displayName = 'TextItalicIcon';
var $1a793c546f0fdfeb$var$_default = module.exports.default = $1a793c546f0fdfeb$var$TextItalicIcon;

});

parcelRegister("cH4SO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad2312c44e56bfe228b05001ebe3e76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93dd49db46b024af$var$_react = $93dd49db46b024af$var$_interopRequireDefault((parcelRequire("42omo")));

var $93dd49db46b024af$var$_baseNew = $93dd49db46b024af$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $93dd49db46b024af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextShorten".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for shortening text content with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93dd49db46b024af$var$TextShortenIcon = (props)=>/*#__PURE__*/ $93dd49db46b024af$var$_react.default.createElement($93dd49db46b024af$var$_baseNew.default, Object.assign({
        name: "TextShortenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zM8 11H1V9.5h7z" clip-rule="evenodd"/>`
    }, props));
$93dd49db46b024af$var$TextShortenIcon.displayName = 'TextShortenIcon';
var $93dd49db46b024af$var$_default = module.exports.default = $93dd49db46b024af$var$TextShortenIcon;

});

parcelRegister("3tLv0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a032fed0c9ceffcd5be1fe3fcd5f364>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2888ecd84ca5bb5c$var$_react = $2888ecd84ca5bb5c$var$_interopRequireDefault((parcelRequire("42omo")));

var $2888ecd84ca5bb5c$var$_baseNew = $2888ecd84ca5bb5c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2888ecd84ca5bb5c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Translate".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing language translations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2888ecd84ca5bb5c$var$TranslateIcon = (props)=>/*#__PURE__*/ $2888ecd84ca5bb5c$var$_react.default.createElement($2888ecd84ca5bb5c$var$_baseNew.default, Object.assign({
        name: "TranslateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.395 4.5H0V3h4V1h1.5v2h4v1.5H6.911c-.252 1.771-.704 3.325-1.338 4.685.471.522.973.973 1.479 1.323l-.854 1.234a10 10 0 0 1-1.377-1.17 12.2 12.2 0 0 1-2.991 3.275l-.91-1.194a10.7 10.7 0 0 0 2.867-3.276 12.5 12.5 0 0 1-1.74-3.114l1.405-.526c.265.706.633 1.418 1.073 2.087.385-.982.68-2.085.87-3.324m5.17 1.945A.75.75 0 0 1 11.25 6h.5a.75.75 0 0 1 .685.445l3.5 7.875a.75.75 0 0 1 .065.305V15h-1.5v-.216L13.707 13H9.293L8.5 14.784V15H7v-.375a.75.75 0 0 1 .065-.305zM9.96 11.5h3.08L11.5 8.034z" clip-rule="evenodd"/>`
    }, props));
$2888ecd84ca5bb5c$var$TranslateIcon.displayName = 'TranslateIcon';
var $2888ecd84ca5bb5c$var$_default = module.exports.default = $2888ecd84ca5bb5c$var$TranslateIcon;

});

parcelRegister("7ZcJJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eef8c7bda009f013e8cf54eb12259e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d081c26badb6644$var$_react = $5d081c26badb6644$var$_interopRequireDefault((parcelRequire("42omo")));

var $5d081c26badb6644$var$_baseNew = $5d081c26badb6644$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5d081c26badb6644$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d081c26badb6644$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $5d081c26badb6644$var$_react.default.createElement($5d081c26badb6644$var$_baseNew.default, Object.assign({
        name: "WorkItemsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$5d081c26badb6644$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $5d081c26badb6644$var$_default = module.exports.default = $5d081c26badb6644$var$WorkItemsIcon;

});

parcelRegister("imt6g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d66a24f642488d17115358045c30773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5e0dac0a739db71$var$_react = $d5e0dac0a739db71$var$_interopRequireDefault((parcelRequire("42omo")));

var $d5e0dac0a739db71$var$_baseNew = $d5e0dac0a739db71$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d5e0dac0a739db71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d5e0dac0a739db71$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $d5e0dac0a739db71$var$_react.default.createElement($d5e0dac0a739db71$var$_baseNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$d5e0dac0a739db71$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $d5e0dac0a739db71$var$_default = module.exports.default = $d5e0dac0a739db71$var$CheckCircleIcon;

});

parcelRegister("d6Fdl", function(module, exports) {
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $29781e74b331cae7$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $29781e74b331cae7$var$svgStyles = null; /**
                         * __SVG__
                         *
                         * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
                         *
                         * An icon is used as a visual representation of common actions and commands to provide context.
                         *
                         * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
                         * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
                         */ 
const $29781e74b331cae7$var$SVG = /*#__PURE__*/ (0, $42omo.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $29781e74b331cae7$var$sizeStyles[size]
        ]),
        children: children
    });
});
var $29781e74b331cae7$export$2e2bcd8739ae039 = $29781e74b331cae7$var$SVG;
module.exports["default"] = $29781e74b331cae7$export$2e2bcd8739ae039;

});

parcelRegister("eCcCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $05a32284d51eddeb$export$2e2bcd8739ae039);
/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $i7jPX = parcelRequire("i7jPX");

const $05a32284d51eddeb$var$sizeCrossCompatibleMap = {
    // Size mapping from old pixel sizes to new t-shirt sizes
    '16': 'xsmall',
    // Not used
    '24': 'small',
    '32': 'medium',
    '40': 'large',
    '48': 'xlarge',
    xsmall: 'xsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
// Icon color mapping for Tile-based icons
const $05a32284d51eddeb$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
// Background color mapping for Tile component
const $05a32284d51eddeb$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $05a32284d51eddeb$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'small', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        size: $05a32284d51eddeb$var$sizeCrossCompatibleMap[size],
        backgroundColor: $05a32284d51eddeb$var$backgroundColorMap[appearance],
        label: label,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $05a32284d51eddeb$var$iconColorMap[appearance]
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)(ExpandedIcon, {
                color: "currentColor",
                label: label,
                shouldScale: true
            })
        })
    });
}

});

parcelRegister("1boGo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed7e3690621b4d12$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $ed7e3690621b4d12$var$sizeCrossCompatibleMap = {
    // Size mapping from new t-shirt sizes to old pixel sizes
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48',
    '16': '16',
    '24': '24',
    '32': '32',
    '40': '40',
    '48': '48'
};
const $ed7e3690621b4d12$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $ed7e3690621b4d12$var$appearanceMap = {
    grayBold: "_bfhk1i45 _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhk16e3 _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkya33 _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhk1qg1 _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk7qp0 _syaz1diz",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhk165s _syaz1j6y",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk1dy8 _syaz6txe",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1nm4 _syazuq3u",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk1773 _syaz1oqg"
};
const $ed7e3690621b4d12$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $ed7e3690621b4d12$var$iconTileStyles = null; /**
                              * __IconTile__
                              *
                              * An icon with background shape, color, and size properties determined by Tile.
                              */ 
function $ed7e3690621b4d12$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $ed7e3690621b4d12$var$appearanceMap[appearance],
            $ed7e3690621b4d12$var$sizeMap[$ed7e3690621b4d12$var$sizeCrossCompatibleMap[size]],
            $ed7e3690621b4d12$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("lebfc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a53e84608f4cc80b860fc333251d7715>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f743a09f7388d5ee$var$_react = $f743a09f7388d5ee$var$_interopRequireDefault((parcelRequire("42omo")));

var $f743a09f7388d5ee$var$_baseNew = $f743a09f7388d5ee$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f743a09f7388d5ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f743a09f7388d5ee$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $f743a09f7388d5ee$var$_react.default.createElement($f743a09f7388d5ee$var$_baseNew.default, Object.assign({
        name: "PeopleGroupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$f743a09f7388d5ee$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $f743a09f7388d5ee$var$_default = module.exports.default = $f743a09f7388d5ee$var$PeopleGroupIcon;

});

parcelRegister("dmbve", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b96409ff05abd17$var$_react = $9b96409ff05abd17$var$_interopRequireDefault((parcelRequire("42omo")));

var $9b96409ff05abd17$var$_baseNew = $9b96409ff05abd17$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9b96409ff05abd17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b96409ff05abd17$var$TaskIcon = (props)=>/*#__PURE__*/ $9b96409ff05abd17$var$_react.default.createElement($9b96409ff05abd17$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$9b96409ff05abd17$var$TaskIcon.displayName = 'TaskIcon';
var $9b96409ff05abd17$var$_default = module.exports.default = $9b96409ff05abd17$var$TaskIcon;

});

parcelRegister("euUgw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8df8328f657c4e4$var$_react = $a8df8328f657c4e4$var$_interopRequireDefault((parcelRequire("42omo")));

var $a8df8328f657c4e4$var$_baseNew = $a8df8328f657c4e4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a8df8328f657c4e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8df8328f657c4e4$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $a8df8328f657c4e4$var$_react.default.createElement($a8df8328f657c4e4$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$a8df8328f657c4e4$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $a8df8328f657c4e4$var$_default = module.exports.default = $a8df8328f657c4e4$var$ArrowUpIcon;

});

parcelRegister("fIcbd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b70469bbb10d3c64$var$_react = $b70469bbb10d3c64$var$_interopRequireDefault((parcelRequire("42omo")));

var $b70469bbb10d3c64$var$_baseNew = $b70469bbb10d3c64$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b70469bbb10d3c64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b70469bbb10d3c64$var$SettingsIcon = (props)=>/*#__PURE__*/ $b70469bbb10d3c64$var$_react.default.createElement($b70469bbb10d3c64$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$b70469bbb10d3c64$var$SettingsIcon.displayName = 'SettingsIcon';
var $b70469bbb10d3c64$var$_default = module.exports.default = $b70469bbb10d3c64$var$SettingsIcon;

});

parcelRegister("ldfch", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11cac724462839f30810a0cf708cc3d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f71699b080e7c7d8$var$_react = $f71699b080e7c7d8$var$_interopRequireDefault((parcelRequire("42omo")));

var $f71699b080e7c7d8$var$_baseNew = $f71699b080e7c7d8$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f71699b080e7c7d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f71699b080e7c7d8$var$EmailIcon = (props)=>/*#__PURE__*/ $f71699b080e7c7d8$var$_react.default.createElement($f71699b080e7c7d8$var$_baseNew.default, Object.assign({
        name: "EmailIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$f71699b080e7c7d8$var$EmailIcon.displayName = 'EmailIcon';
var $f71699b080e7c7d8$var$_default = module.exports.default = $f71699b080e7c7d8$var$EmailIcon;

});

parcelRegister("ctmPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61e479f96d30ea6369ef34d699ad08b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9149e5f25e2e49d4$var$_react = $9149e5f25e2e49d4$var$_interopRequireDefault((parcelRequire("42omo")));

var $9149e5f25e2e49d4$var$_baseNew = $9149e5f25e2e49d4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $9149e5f25e2e49d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9149e5f25e2e49d4$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $9149e5f25e2e49d4$var$_react.default.createElement($9149e5f25e2e49d4$var$_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$9149e5f25e2e49d4$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $9149e5f25e2e49d4$var$_default = module.exports.default = $9149e5f25e2e49d4$var$OfficeBuildingIcon;

});

parcelRegister("d8ohW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88b78ca28318b361f543778979c0dbc2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98fedce282442e3d$var$_react = $98fedce282442e3d$var$_interopRequireDefault((parcelRequire("42omo")));

var $98fedce282442e3d$var$_baseNew = $98fedce282442e3d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $98fedce282442e3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98fedce282442e3d$var$RetryIcon = (props)=>/*#__PURE__*/ $98fedce282442e3d$var$_react.default.createElement($98fedce282442e3d$var$_baseNew.default, Object.assign({
        name: "RetryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$98fedce282442e3d$var$RetryIcon.displayName = 'RetryIcon';
var $98fedce282442e3d$var$_default = module.exports.default = $98fedce282442e3d$var$RetryIcon;

});

parcelRegister("7yOcR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5812a758b5046e3e$var$_react = $5812a758b5046e3e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5812a758b5046e3e$var$_baseNew = $5812a758b5046e3e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5812a758b5046e3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5812a758b5046e3e$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5812a758b5046e3e$var$_react.default.createElement($5812a758b5046e3e$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5812a758b5046e3e$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5812a758b5046e3e$var$_default = module.exports.default = $5812a758b5046e3e$var$FeedbackIcon;

});

parcelRegister("4ymSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::039ea8d33e9a1538394bd0f26af6a9f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $350c165651252fe4$var$_react = $350c165651252fe4$var$_interopRequireDefault((parcelRequire("42omo")));

var $350c165651252fe4$var$_baseNew = $350c165651252fe4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $350c165651252fe4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Table".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for tables, tabular data, and spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $350c165651252fe4$var$TableIcon = (props)=>/*#__PURE__*/ $350c165651252fe4$var$_react.default.createElement($350c165651252fe4$var$_baseNew.default, Object.assign({
        name: "TableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8.75h-8v3.75H14a.5.5 0 0 0 .5-.5zM1.5 12a.5.5 0 0 0 .5.5h3V8.75H1.5zm13-8a.5.5 0 0 0-.5-.5H6.5v3.75h8zm-13 3.25H5V3.5H2a.5.5 0 0 0-.5.5zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$350c165651252fe4$var$TableIcon.displayName = 'TableIcon';
var $350c165651252fe4$var$_default = module.exports.default = $350c165651252fe4$var$TableIcon;

});

parcelRegister("4fdTR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba6b12c8d889bd288c998a8deb3aaaee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3173586632594720$var$_react = $3173586632594720$var$_interopRequireDefault((parcelRequire("42omo")));

var $3173586632594720$var$_baseNew = $3173586632594720$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3173586632594720$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3173586632594720$var$SendIcon = (props)=>/*#__PURE__*/ $3173586632594720$var$_react.default.createElement($3173586632594720$var$_baseNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$3173586632594720$var$SendIcon.displayName = 'SendIcon';
var $3173586632594720$var$_default = module.exports.default = $3173586632594720$var$SendIcon;

});

parcelRegister("eqRDX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbe84f7904a3024f7679b2cd62914cc0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a81d1add0f429e35$var$_react = $a81d1add0f429e35$var$_interopRequireDefault((parcelRequire("42omo")));

var $a81d1add0f429e35$var$_checkCircle = $a81d1add0f429e35$var$_interopRequireDefault((parcelRequire("imt6g")));

var $a81d1add0f429e35$var$_checkCircle2 = $a81d1add0f429e35$var$_interopRequireDefault((parcelRequire("eCByP")));
function $a81d1add0f429e35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a81d1add0f429e35$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $a81d1add0f429e35$var$_react.default.createElement($a81d1add0f429e35$var$_checkCircle.default, Object.assign({
        name: "CheckCircleIcon",
        LEGACY_fallbackIcon: $a81d1add0f429e35$var$_checkCircle2.default
    }, props));
$a81d1add0f429e35$var$CheckCircleIcon.displayName = 'CheckCircleIconMigration';
var $a81d1add0f429e35$var$_default = module.exports.default = $a81d1add0f429e35$var$CheckCircleIcon;

});

parcelRegister("7O0l1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c6f56c8361c40e1c778ba50713dcedd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5aed7706936fc747$var$_react = $5aed7706936fc747$var$_interopRequireDefault((parcelRequire("42omo")));

var $5aed7706936fc747$var$_baseNew = $5aed7706936fc747$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5aed7706936fc747$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5aed7706936fc747$var$DepartmentIcon = (props)=>/*#__PURE__*/ $5aed7706936fc747$var$_react.default.createElement($5aed7706936fc747$var$_baseNew.default, Object.assign({
        name: "DepartmentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$5aed7706936fc747$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $5aed7706936fc747$var$_default = module.exports.default = $5aed7706936fc747$var$DepartmentIcon;

});


$parcel$global.rlb("ffEVr")
//# sourceMappingURL=vendors~editor_icon.714307c6.js.map
